import { MountBuilderPreviewModal } from './MountBuilderPreviewModal.js';

const MOUNT_BUILDER_PROXY_API_ENDPOINT = '/apps/proxy';
const MOUNT_BUILDER_PROXY_TARGET_BUILDER = 'mount-builder-v3';
const MOUNT_BUILDER_CART_SECTIONS = ['minicart-items', 'cart-toggle-with-item-count'];

class MountBuilder extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('[data-builder-content]');
    this.context = null;
    this.back = this.querySelector('#back-btn');
    this.minicart = document.querySelector('mini-cart');
    this.startOver = this.querySelector('[data-start-over]');
    this.allResults = this.querySelector('[data-all-results]');
    this.allResultsAtResultPage = this.querySelector('[data-show-end-result-collection]');
    this.backBtnSpacer = this.querySelector('.back-btn-spacer');
    this.resultsBtnSpacer = this.querySelector('.results-btn-spacer');
    this.disableHeading = false;
    this.shopifyUrl = window.location.origin;
    this.breadContainer = document.getElementById('breadcrumbContainer');
    this.apiKey = this.getAttribute('data-api-key');
    this.isInitialLoad = true;
    this.previewModal = new MountBuilderPreviewModal();
    this.enableSideCart = this.getAttribute('data-enable-side-cart') === 'true';
    this.sideCart = document.getElementById('kit-side-cart');
    this.sideCartItems = document.getElementById('side-cart-items');
    this.sideCartSubtotal = document.getElementById('side-cart-subtotal');
    this.sideCartCount = document.getElementById('side-cart-count');
    this.sideCartAddBtn = document.getElementById('side-cart-add-btn');
    this.mobileBar = document.getElementById('kit-mobile-bar');
    this.mobileBarSubtotal = document.getElementById('mobile-bar-subtotal');
    this.mobileBarViewBtn = document.getElementById('mobile-bar-view-btn');
    this.mobileDrawer = document.getElementById('kit-mobile-drawer');
    this.mobileDrawerItems = document.getElementById('mobile-drawer-items');
    this.mobileDrawerCount = document.getElementById('mobile-drawer-count');
    this.mobileDrawerSubtotal = document.getElementById('mobile-drawer-subtotal');
    this.mobileDrawerAddBtn = document.getElementById('mobile-drawer-add-btn');
    this.kitProducts = [];

    // Store the initial context for comparison
    this.initialContext = null;
    const dataInitialContext = this.getAttribute('data-initial-context');

    if (dataInitialContext && dataInitialContext !== '' && dataInitialContext !== 'e30=') {
      try {
        const decodedContext = atob(dataInitialContext);
        this.initialContext = JSON.parse(decodedContext);
      } catch (e) {
        console.error('Invalid initial context:', e);
        this.initialContext = null;
      }
    }
  }

  connectedCallback() {
    this.start();

    if (this.back) {
      this.back.addEventListener('click', (e) => {
        this.goBack(e);
      });
    }

    if (this.startOver) {
      this.startOver.addEventListener('click', (e) => {
        this.start(e);
      });
    }

    // Initially hide back button and show spacer
    this.toggleButtonVisibility('#back-btn', false);

    // Clean up URL parameters when leaving results page
    this.setupNavigationCleanup();

    if (!this.breadContainer) {
      console.error('breadContainer not found! Looking for it again...');
      this.breadContainer = document.getElementById('breadcrumbContainer');
    }

    // Attach click event listeners to breadcrumbs
    if (this.breadContainer) {
      this.breadContainer.addEventListener('click', (e) => {

        // Find the clicked link
        const link = e.target.closest('a');

        if (!link) return;

        e.preventDefault();

        let contextData = null;

        // Check for home breadcrumb (SVG path element has the data)
        const homePath = link.querySelector('.home-breadcrumb-step');
        if (homePath) {
          contextData = homePath.dataset.newContext;
        }

        // Check for regular breadcrumb (link element has the data)
        const breadcrumbLink = link.classList.contains('breadcrumb-step') ? link : link.querySelector('.breadcrumb-step');
        if (breadcrumbLink) {
          contextData = breadcrumbLink.dataset.newContext;
        }

        // Navigate if we found context data
        if (contextData) {
          try {
            const context = JSON.parse(contextData);
            this.navigateToContext(context);
          } catch (error) {
            console.error('Error parsing breadcrumb context:', error, contextData);
          }
        }
      });
    } else {
      console.error('Cannot attach breadcrumb listener - breadContainer is null!');
    }

    if (this.enableSideCart) {
      this.setupSideCart();
    }

    this.setupHelpModal();
  }

  toggleButtonVisibility(selector, show) {
    const button = this.querySelector(selector);
    if (button) {
      if (show) {
        button.classList.remove('hidden');
        // Hide corresponding spacer
        if (selector === '#back-btn' && this.backBtnSpacer) {
          this.backBtnSpacer.style.display = 'none';
        } else if ((selector === '[data-all-results]' || selector === '[data-show-end-result-collection]') && this.resultsBtnSpacer) {
          // Check if both results buttons would be hidden
          const allResultsHidden = this.allResults.classList.contains('hidden');
          const endResultsHidden = this.allResultsAtResultPage.classList.contains('hidden');
          if (!allResultsHidden || !endResultsHidden) {
            this.resultsBtnSpacer.style.display = 'none';
          }
        }
      } else {
        button.classList.add('hidden');
        // Show corresponding spacer
        if (selector === '#back-btn' && this.backBtnSpacer) {
          this.backBtnSpacer.style.display = 'block';
        } else if ((selector === '[data-all-results]' || selector === '[data-show-end-result-collection]') && this.resultsBtnSpacer) {
          // Check if both results buttons are now hidden
          const allResultsHidden = selector === '[data-all-results]' ? true : this.allResults.classList.contains('hidden');
          const endResultsHidden = selector === '[data-show-end-result-collection]' ? true : this.allResultsAtResultPage.classList.contains('hidden');
          if (allResultsHidden && endResultsHidden) {
            this.resultsBtnSpacer.style.display = 'block';
          }
        }
      }
    }
  }

  async sendRequest(body) {
    // if(!this.disableHeading && (body != "START_BUILDER")){
    //   this.breadContainer.classList.add('hidden');
    //   this.disableHeading = true;
    // }

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "text/plain");
    myHeaders.append("X-Target-Endpoint", MOUNT_BUILDER_PROXY_TARGET_BUILDER);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(body)
    };

    try {
      const proxyUrl = new URL(MOUNT_BUILDER_PROXY_API_ENDPOINT, window.location.origin);
      proxyUrl.searchParams.set('target', MOUNT_BUILDER_PROXY_TARGET_BUILDER);
      const response = await fetch(proxyUrl.toString(), requestOptions);

      if (response.headers.get('X-API-Deprecated') === 'true') {
        console.warn('API Deprecation Warning:', {
          version: response.headers.get('X-API-Version'),
          sunsetDate: response.headers.get('X-API-Sunset'),
          message: response.headers.get('X-API-Deprecation-Message')
        });
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      this.context = await response.json();
    } catch (error) {
      console.error('Error:', error);
    }
  }

  // async sendRequest(body){
  //   if(!this.disableHeading && (body != "START_BUILDER")){
  //     this.manageClasses([ { selector: '#breadcrumbContainer', class: 'hidden', action: 'add' } ])
  //     this.disableHeading = true;
  //   }
  //   const myHeaders = new Headers();
  //   myHeaders.append("Content-Type", "text/plain");
  //   const requestOptions = {
  //     method: 'POST',
  //     headers: myHeaders,
  //     body: JSON.stringify(body)
  //   };
  //   let results = null;
  //   const baseUrl = this.shopifyUrl === "https://rammount-development.myshopify.com"
  //   ? "https://shopify-mount-builder-staging.rammount.com/mntbuilder?key=gNz!W%232Pyeu8RdKGzA4%25SWrr"
  //   : "https://shopify-mount-builder.rammount.com/mntbuilder?key=gNz!W%232Pyeu8RdKGzA4%25SWrr";

  //   // const baseUrl = "https://shopify-mount-builder-staging.rammount.com/mntbuilder?key=gNz!W%232Pyeu8RdKGzA4%25SWrr";

  //   await fetch(baseUrl, requestOptions)
  //   .then(response => response.json())
  //   .then(result => {
  //     results = result
  //    })
  //   .catch(error => console.log('error', error));
  //   this.context = results;
  //   return;

  // }

  async start(){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    let initial_context = {};

    const dataInitialContext = this.getAttribute('data-initial-context');

    if (dataInitialContext && dataInitialContext !== '' && dataInitialContext !== 'e30=') {
      try {
        const decodedContext = atob(dataInitialContext);
        initial_context = JSON.parse(decodedContext);
      } catch (e) {
        console.error('Invalid initial context:', e);
        initial_context = {};
      }
    }

    urlParams.forEach((value, key) => {
      initial_context[key] = decodeURIComponent(value);
    });

    // Store the complete initial context (including URL params)
    if (Object.keys(initial_context).length > 0) {
      this.initialContext = {...initial_context};
    }

    initial_context = (Object.keys(initial_context).length > 0) ? initial_context : 'START_BUILDER';

    await this.sendRequest(initial_context)

    if(this.context){
      // Use new toggle method for cleaner visibility control
      this.toggleButtonVisibility('[data-all-results]', false);
      this.toggleButtonVisibility('[data-show-end-result-collection]', false);
      this.toggleButtonVisibility('[data-start-over]', false);

      setTimeout(()=> {
        try {
          gtag("event", "mount_builder_started", { value: this.context });
        } catch (err) {
        }
      }, 300);

      this.buildStep();

      // Hide side cart on initial load if not results page
      if (this.enableSideCart && this.context.page_type !== 'results') {
        this.hideSideCart();
        this.showHelpModalFooter();
      }

      this.isInitialLoad = false;
    }
  }

  setupHelpModal() {
    const sideCartHelpLink = document.getElementById('side-cart-help-link');
    const footerHelpLink = document.getElementById('footer-help-link');
    const modal = document.getElementById('help-modal');
    const closeBtn = document.getElementById('help-modal-close');
    const backdrop = modal?.querySelector('.help-modal-backdrop');

    if (!modal) return;

    // Open modal from side cart help link
    if (sideCartHelpLink) {
      sideCartHelpLink.addEventListener('click', (e) => {
        e.preventDefault();
        this.openHelpModal();
      });
    }

    // Open modal from footer help link
    if (footerHelpLink) {
      footerHelpLink.addEventListener('click', (e) => {
        e.preventDefault();
        this.openHelpModal();
      });
    }

    // Close modal on close button click
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        this.closeHelpModal();
      });
    }

    // Close modal on backdrop click
    if (backdrop) {
      backdrop.addEventListener('click', () => {
        this.closeHelpModal();
      });
    }

    // Close modal on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        this.closeHelpModal();
      }
    });
  }

  openHelpModal() {
    const modal = document.getElementById('help-modal');
    if (modal) {
      modal.classList.remove('hidden');
      // Use setTimeout to allow the display change to take effect before adding active class
      setTimeout(() => {
        modal.classList.add('active');
        document.body.classList.add('modal-open');
      }, 10);
    }
  }

  closeHelpModal() {
    const modal = document.getElementById('help-modal');
    if (modal) {
      modal.classList.remove('active');
      document.body.classList.remove('modal-open');
      // Wait for transition to complete before hiding
      setTimeout(() => {
        modal.classList.add('hidden');
      }, 300);
    }
  }

  async goBack(){
    // Clear tab state when going back
    sessionStorage.removeItem('mountBuilder_activeTab');
    sessionStorage.removeItem('mountBuilder_refreshTab');

    // Clear the kit when navigating away from results
    if (this.context.page_type === 'results') {
      this.kitProducts = [];
    }

    if(this.context.accessories_active){
      this.context.accessories_active = false;
      if(this.context){
        this.buildStep();
      }
    }else{
      // Check if going back would take us to or past the initial context
      if (this.initialContext && this.wouldGoBackToOrPastInitial()) {
        // Navigate to initial context instead
        await this.navigateToContext(this.initialContext);
      } else {
        // Normal back behavior
        this.context.context.go_back = 1;
        await this.navigateToContext(this.context.context);
      }
    }
  }

  isContextEqual(context1, context2) {
    if (!context1 || !context2) return false;

    const keys1 = Object.keys(context1);
    const keys2 = Object.keys(context2);

    if (keys1.length !== keys2.length) return false;

    for (let key of keys1) {
      if (context1[key] !== context2[key]) return false;
    }

    return true;
  }

  wouldGoBackToOrPastInitial() {
    // This checks if going back would reach the initial context
    if (!this.context.breadcrumbs) return false;

    let breadcrumbs = this.context.breadcrumbs;
    if (typeof breadcrumbs === 'string') {
      try {
        breadcrumbs = JSON.parse(breadcrumbs);
      } catch (e) {
        return false;
      }
    }

    // If we only have 2 breadcrumbs (Home and current), going back would reach initial
    return Object.keys(breadcrumbs).length <= 2;
  }

  setupNavigationCleanup() {
    // Clean hash on page load/refresh
    const tabHashes = ['#option-1', '#option-2', '#option-3'];
    if (tabHashes.includes(window.location.hash)) {
      // Store which tab was selected before cleaning
      const selectedTab = window.location.hash.substring(1);
      sessionStorage.setItem('mountBuilder_refreshTab', selectedTab);

      // Clean the hash immediately
      const cleanUrl = window.location.href.split('#')[0];
      window.history.replaceState({}, '', cleanUrl);
    }

    // Listen for popstate events (browser back/forward)
    window.addEventListener('popstate', (e) => {
      this.cleanTabParameters();
      // Re-initialize based on current state
      if (this.context && this.context.page_type === 'results') {
        // Force rebuild without tab parameters
        this.buildStep();
      }
    });

    // Clean URL when navigating away from results
    window.addEventListener('beforeunload', () => {
      if (this.context && this.context.page_type === 'results') {
        this.cleanTabParameters();
      }
    });
  }

  cleanTabParameters() {
    const url = new URL(window.location);
    let hashChanged = false;

    // Check if hash is one of the option tabs
    const tabHashes = ['#option-1', '#option-2', '#option-3'];
    if (tabHashes.includes(url.hash)) {
      url.hash = '';
      hashChanged = true;
    }

    if (hashChanged) {
      // Use replaceState to update URL without triggering navigation
      window.history.replaceState({}, '', url.toString());
    }
  }

  buildStep(){
    this.breadContainer.innerHTML = this.generateBreadcrumb(this.context.breadcrumbs);

  // Hide side cart if not on results page or wrong data set
  if (this.enableSideCart && this.context.page_type !== 'results') {
    this.hideSideCart();
    this.showHelpModalFooter();
  }

    // Check if current context matches initial context
    const isAtInitialContext = this.isContextEqual(this.context.context, this.initialContext);

    const hasContext = Object.keys(this.context.context).length > 0 && !isAtInitialContext;
    const hasExtraUrl = this.context.extra_url && this.context.extra_url.length > 0;
    const hasFinalUrl = this.context.final_url && this.context.final_url.length > 0;

    if (window.location.pathname === '/pages/mount-builder') {
        window.scrollTo(0, 0);
    }

    // Use the new toggle method for all button visibility changes
    this.toggleButtonVisibility('#back-btn', hasContext);
    this.toggleButtonVisibility('[data-start-over]', hasContext);
    this.toggleButtonVisibility('[data-all-results]', hasExtraUrl);
    this.toggleButtonVisibility('[data-show-end-result-collection]', hasFinalUrl);

    // Update event listeners for extraUrl and finalURL
    if (hasExtraUrl) {
      let extraUrl = window.location.protocol + "//" + window.location.hostname + this.context.extra_url[0];
      this.allResults.removeEventListener('click', this.previousExtraUrlHandler);
      this.previousExtraUrlHandler = () => window.open(extraUrl, '_blank');
      this.allResults.addEventListener('click', this.previousExtraUrlHandler);
    }
    if (hasFinalUrl) {
      let finalURL = window.location.protocol + "//" + window.location.hostname + this.context.final_url[0];
      this.allResultsAtResultPage.removeEventListener('click', this.previousFinalUrlHandler);
      this.previousFinalUrlHandler = () => window.open(finalURL, '_blank');
      this.allResultsAtResultPage.addEventListener('click', this.previousFinalUrlHandler);
    }

    let steps = JSON.stringify(this.context.context).slice(1, -1);

    switch(this.context.page_type) {
      case "image_list":
        try {
          gtag("event", "builder_step_completed", { steps });
        } catch (err) {
        }
        this.buildImageList(this.context)
        break;
      case "dropdowns":
        this.buildDropDown(this.context)
        break;
      case "results":
        if (this.context.final_url && this.context.final_url.length > 0 && this.context.parts.length == 0){
          const finalURL = window.location.protocol + "//" + window.location.hostname + this.context.final_url[0]
          window.location.assign(finalURL)
          break;
        }else{
          this.buildResults(this.context)
        }
      default:
        break;
    }
  }

  async loadProductTile(options, selector, callback) {
    if (options && options.length > 0) {
        try {
          const fetchPromises = options.map(option =>
            fetch(`${window.routes.root_url}products/${option.toLowerCase()}/?section_id=api-product-tile`).then(response => response.text())
          );
          const responses = await Promise.all(fetchPromises);
          const productTiles = responses.map(text =>
            new DOMParser().parseFromString(text, 'text/html').querySelector('[data-api-content]').innerHTML
          ).join('');

          // Update the innerHTML of the selector with all product tiles
          this.container.querySelector(selector).innerHTML = productTiles;

          // Add event listeners to 'Add to Cart' buttons
          const addToCartButtons = [...this.container.querySelectorAll('[data-add-to-cart]')];
          addToCartButtons.forEach(el => {
            el.addEventListener('click', e => {
              // Route to kit side cart if visible, otherwise add to cart directly
              if (this.shouldShowSideCart()) {
                this.addToKitSideCart(e);
              } else {
                this.addToCartSingle(e);
              }
            });
          });

          // Update button text if side cart is visible
          this.updateProductCardButtonText();

          // Call the callback function after the product tiles are loaded
          if (callback && typeof callback === 'function') {
            callback();
          }
        } catch (e) {
            console.error(e);
        }
    }
  }

  async notifyLookup(options) {
    // Only used for hiding add bundle option - We can break out if any is found
    let notifyCheck = null;

    if (options && options.length > 0) {
      for (let i = 0; i < options.length; i++) {
        try {
          const response = await fetch(`${window.routes.root_url}products/${options[i].toLowerCase()}.js`);
          const json = await response.json();
          // console.log('notify check', json)

          if (json["available"] === false) {
            notifyCheck = true;
            break;
          }
        } catch (e) {
          console.error(e);
        }
      }
    }

    return notifyCheck;
  }

  // Show loading overlay
  showLoading() {
    const enableLoading = this.getAttribute('data-enable-results-loading') === 'true';

    if (enableLoading && !this.isInitialLoad) {
      const loadingOverlay = document.getElementById('loading-overlay');
      if (loadingOverlay) {
        loadingOverlay.style.display = 'flex';
        document.body.classList.add('loading-active');
      }
    }
  }

  // Hide loading overlay
  hideLoading() {
    const enableLoading = this.getAttribute('data-enable-results-loading') === 'true';

    if (enableLoading) {
      const loadingOverlay = document.getElementById('loading-overlay');
      if (loadingOverlay) {
        loadingOverlay.style.display = 'none';
        document.body.classList.remove('loading-active');
      }
    }
  }

  setupSideCart() {
    // Setup event listeners for add to cart buttons
    if (this.sideCartAddBtn) {
      this.sideCartAddBtn.addEventListener('click', () => this.addKitToCart());
    }

    // Mobile drawer setup
    if (this.mobileBarViewBtn) {
      this.mobileBarViewBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.openMobileDrawer();
      });
    }

    // Also make the entire mobile bar clickable
    if (this.mobileBar) {
      this.mobileBar.addEventListener('click', () => this.openMobileDrawer());
    }

    if (this.mobileDrawerAddBtn) {
      this.mobileDrawerAddBtn.addEventListener('click', () => {
        this.addKitToCart();
        this.closeMobileDrawer();
      });
    }

    // Backdrop click to close
    if (this.mobileDrawer) {
      const backdrop = this.mobileDrawer.querySelector('.kit-drawer-backdrop');
      if (backdrop) {
        backdrop.addEventListener('click', () => this.closeMobileDrawer());
      }
    }

    // Setup swipe down to close
    this.setupMobileDrawerSwipe();

    // Setup help modal for mobile drawer
    const mobileHelpLink = document.getElementById('mobile-drawer-help-link');
    if (mobileHelpLink) {
      mobileHelpLink.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeMobileDrawer();
        this.openHelpModal();
      });
    }
  }

  shouldShowSideCart() {
    if (!this.enableSideCart || !this.context || !this.context.context) return false;

    // Only show on results page
    if (this.context.page_type !== 'results') return false;

    const dataSet = this.context.context.data_set;
    return dataSet === 'Push-to-talk Kits' || dataSet === 'Device';
  }

  updateSideCart() {
    if (!this.enableSideCart || !this.shouldShowSideCart()) {
      this.hideSideCart();
      this.showHelpModalFooter();
      return;
    }

    // Auto-collect all available products from current page to populate the kit
    this.kitProducts = this.collectKitProducts();

    // Update side cart display
    this.renderSideCartItems();
    this.updateSideCartSubtotal();
    this.updateProductCardButtonText();
    this.showSideCart();
    this.hideHelpModalFooter();
  }

  collectKitProducts() {
    const products = [];

    // Get visible tab panes
    const visibleTabPanes = this.container.querySelectorAll('.tab-pane:not(.hidden)');

    visibleTabPanes.forEach(pane => {
      // Skip accessories section - they should only be added manually
      if (pane.id === 'accessories-grid' || pane.closest('#accessories-grid')) {
        return;
      }

      // Modern cards
      const modernCards = pane.querySelectorAll('.modern-product-card');
      modernCards.forEach(card => {
        // Skip accessories - they should only be added manually
        if (card.closest('#accessories-grid')) {
          return;
        }
        if (card.dataset.available !== 'false') {
          products.push(this.extractProductData(card));
        }
      });

      // Legacy tiles
      const legacyTiles = pane.querySelectorAll('product-tile');
      legacyTiles.forEach(tile => {
        if (tile.dataset.available !== 'false') {
          products.push(this.extractProductData(tile));
        }
      });
    });

    // DO NOT auto-collect accessories - they should only be added manually via "Add to Kit" button

    return products;
  }

  extractProductData(element) {
    return {
      id: element.dataset.id || element.dataset.variantId,
      title: element.dataset.title || element.querySelector('[data-title]')?.textContent || 'Product',
      sku: element.dataset.sku || '',
      price: parseFloat(element.dataset.productPrice || element.dataset.price || 0),
      image: element.dataset.image || element.querySelector('img')?.src || '',
      handle: element.dataset.productHandle || ''
    };
  }

  renderSideCartItems() {
    if (!this.sideCartItems) return;

    this.sideCartItems.innerHTML = '';

    this.kitProducts.forEach((product, index) => {
      const itemHTML = `
        <div class="side-cart-item" data-product-index="${index}">
          <div class="side-cart-item-image">
            <img src="${product.image}" alt="${product.title}" />
          </div>
          <div class="side-cart-item-content">
            <button
              class="side-cart-item-remove"
              data-remove-index="${index}"
              aria-label="Remove item"
            >×</button>
            <div class="side-cart-item-title">${product.title}</div>
            <div class="side-cart-item-details">
              <div class="side-cart-item-price">$${product.price.toFixed(2)}</div>
              <div class="side-cart-item-quantity">
                <button
                  class="quantity-decrease"
                  data-index="${index}"
                >−</button>
                <input
                  type="number"
                  class="quantity-input"
                  data-index="${index}"
                  value="${product.quantity || 1}"
                  min="0"
                  max="99"
                />
                <button
                  class="quantity-increase"
                  data-index="${index}"
                >+</button>
              </div>
            </div>
          </div>
        </div>
      `;
      this.sideCartItems.insertAdjacentHTML('beforeend', itemHTML);
    });

    // Update count with proper pluralization
    if (this.sideCartCount) {
      const count = this.kitProducts.reduce((sum, p) => sum + (p.quantity || 1), 0);
      this.sideCartCount.textContent = `(${count}) ${count === 1 ? 'Item' : 'Items'}`;
    }

    // Add event listeners for remove buttons
    this.sideCartItems.querySelectorAll('.side-cart-item-remove').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const index = parseInt(e.target.dataset.removeIndex);
        this.removeKitProduct(index);
      });
    });

    // Add event listeners for quantity changes
    this.sideCartItems.querySelectorAll('.quantity-decrease').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const index = parseInt(e.target.dataset.index);
        this.updateKitProductQuantity(index, -1);
      });
    });

    this.sideCartItems.querySelectorAll('.quantity-increase').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const index = parseInt(e.target.dataset.index);
        this.updateKitProductQuantity(index, 1);
      });
    });

    this.sideCartItems.querySelectorAll('.quantity-input').forEach(input => {
      input.addEventListener('change', (e) => {
        const index = parseInt(e.target.dataset.index);
        const newQty = parseInt(e.target.value);
        if (!isNaN(newQty) && newQty <= 50000) {
          // setKitProductQuantity handles removal if newQty < 1
          this.setKitProductQuantity(index, newQty);
        } else {
          // Invalid input, reset to current quantity
          e.target.value = this.kitProducts[index].quantity || 1;
        }
      });
    });
  }

  removeKitProduct(index) {
    this.kitProducts.splice(index, 1);
    this.renderSideCartItems();
    this.updateSideCartSubtotal();
  }

  updateKitProductQuantity(index, change) {
    if (!this.kitProducts[index].quantity) {
      this.kitProducts[index].quantity = 1;
    }

    const newQuantity = this.kitProducts[index].quantity + change;

    // If quantity would go below 1, remove the product instead
    if (newQuantity < 1) {
      this.removeKitProduct(index);
      return;
    }

    this.kitProducts[index].quantity = newQuantity;
    this.renderSideCartItems();
    this.updateSideCartSubtotal();
  }

  setKitProductQuantity(index, quantity) {
    // If quantity is 0 or less, remove the product
    if (quantity < 1) {
      this.removeKitProduct(index);
      return;
    }

    this.kitProducts[index].quantity = quantity;
    this.renderSideCartItems();
    this.updateSideCartSubtotal();
  }

  updateSideCartSubtotal() {
    const subtotal = this.kitProducts.reduce((sum, product) => {
      const qty = product.quantity || 1;
      return sum + (product.price * qty);
    }, 0);
    const formattedSubtotal = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(subtotal);

    if (this.sideCartSubtotal) {
      this.sideCartSubtotal.textContent = formattedSubtotal;
    }
    if (this.mobileBarSubtotal) {
      this.mobileBarSubtotal.textContent = formattedSubtotal;
    }
    if (this.mobileDrawerSubtotal) {
      this.mobileDrawerSubtotal.textContent = formattedSubtotal;
    }
  }

  showSideCart() {
    if (this.sideCart) {
      this.sideCart.classList.remove('hidden');
    }
    if (this.mobileBar) {
      this.mobileBar.classList.remove('hidden');
    }
  }

  hideSideCart() {
    if (this.sideCart) {
      this.sideCart.classList.add('hidden');
    }
    if (this.mobileBar) {
      this.mobileBar.classList.add('hidden');
    }
    if (this.mobileDrawer) {
      this.mobileDrawer.classList.add('hidden');
    }
  }

  hideHelpModalFooter() {
    const helpModalFooter = document.getElementById('help-modal-footer');
    if (helpModalFooter) {
      helpModalFooter.classList.add('hidden');
    }
  }

  showHelpModalFooter() {
    const helpModalFooter = document.getElementById('help-modal-footer');
    if (helpModalFooter) {
      helpModalFooter.classList.remove('hidden');
    }
  }

  openMobileDrawer() {
    if (!this.mobileDrawer) return;

    // Render items in drawer
    this.renderMobileDrawerItems();

    // Lock body scroll using the same technique as MountBuilderPreviewModal
    this._lockDrawerScroll();

    // Show drawer
    this.mobileDrawer.classList.remove('hidden');

    // Use requestAnimationFrame to ensure the display change takes effect before adding active class
    requestAnimationFrame(() => {
      this.mobileDrawer.classList.add('active');
    });
  }

  closeMobileDrawer() {
    if (!this.mobileDrawer) return;

    this.mobileDrawer.classList.remove('active');

    // Wait for animation to complete before hiding and unlocking scroll
    setTimeout(() => {
      if (!this.mobileDrawer.classList.contains('active')) {
        this.mobileDrawer.classList.add('hidden');
        this._unlockDrawerScroll();
      }
    }, 300);
  }

  _lockDrawerScroll() {
    this.drawerScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    document.body.style.cssText = `
      position: fixed !important;
      top: -${this.drawerScrollPosition}px !important;
      left: 0 !important;
      right: 0 !important;
      width: 100% !important;
      overflow: hidden !important;
      padding-right: ${scrollbarWidth}px !important;
    `;

    document.documentElement.style.overflow = 'hidden';
    document.body.setAttribute('data-drawer-scroll-locked', 'true');
  }

  _unlockDrawerScroll() {
    document.body.removeAttribute('data-drawer-scroll-locked');
    document.body.style.cssText = '';
    document.documentElement.style.overflow = '';

    if (this.drawerScrollPosition !== undefined) {
      window.scrollTo(0, this.drawerScrollPosition);
      this.drawerScrollPosition = undefined;
    }
  }

  renderMobileDrawerItems() {
    if (!this.mobileDrawerItems) return;

    this.mobileDrawerItems.innerHTML = '';

    this.kitProducts.forEach((product, index) => {
      const itemHTML = `
        <div class="mobile-kit-item" data-product-index="${index}">
          <div class="mobile-kit-item-image">
            <img src="${product.image}" alt="${product.title}" />
          </div>
          <div class="mobile-kit-item-content">
            <button
              class="mobile-kit-item-remove"
              data-remove-index="${index}"
              aria-label="Remove item"
            >×</button>
            <div class="mobile-kit-item-title">${product.title}</div>
            <div class="mobile-kit-item-price">$${product.price.toFixed(2)}</div>
            <div class="mobile-kit-item-quantity">
              <button
                class="quantity-decrease"
                data-index="${index}"
              >−</button>
              <input
                type="number"
                class="quantity-input"
                data-index="${index}"
                value="${product.quantity || 1}"
                min="0"
                max="99"
              />
              <button
                class="quantity-increase"
                data-index="${index}"
              >+</button>
            </div>
          </div>
        </div>
      `;
      this.mobileDrawerItems.insertAdjacentHTML('beforeend', itemHTML);
    });

    // Update count with proper pluralization
    if (this.mobileDrawerCount) {
      const count = this.kitProducts.reduce((sum, p) => sum + (p.quantity || 1), 0);
      this.mobileDrawerCount.textContent = `(${count}) ${count === 1 ? 'Item' : 'Items'}`;
    }

    // Add event listeners for remove buttons
    this.mobileDrawerItems.querySelectorAll('.mobile-kit-item-remove').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const index = parseInt(e.target.dataset.removeIndex);
        this.removeKitProduct(index);
        this.renderMobileDrawerItems(); // Re-render drawer
      });
    });

    // Add event listeners for quantity changes
    this.mobileDrawerItems.querySelectorAll('.quantity-decrease').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const index = parseInt(e.target.dataset.index);
        this.updateKitProductQuantity(index, -1);
        this.renderMobileDrawerItems(); // Re-render drawer
      });
    });

    this.mobileDrawerItems.querySelectorAll('.quantity-increase').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const index = parseInt(e.target.dataset.index);
        this.updateKitProductQuantity(index, 1);
        this.renderMobileDrawerItems(); // Re-render drawer
      });
    });

    this.mobileDrawerItems.querySelectorAll('.quantity-input').forEach(input => {
      input.addEventListener('change', (e) => {
        const index = parseInt(e.target.dataset.index);
        const newQty = parseInt(e.target.value);
        if (!isNaN(newQty) && newQty <= 50000) {
          this.setKitProductQuantity(index, newQty);
          this.renderMobileDrawerItems(); // Re-render drawer
        } else {
          e.target.value = this.kitProducts[index]?.quantity || 1;
        }
      });
    });
  }

  setupMobileDrawerSwipe() {
    if (!this.mobileDrawer) return;

    const drawerContent = this.mobileDrawer.querySelector('.kit-drawer-content');
    if (!drawerContent) return;

    let startY = 0;
    let currentY = 0;
    let isDragging = false;

    const handleStart = (e) => {
      const touch = e.touches ? e.touches[0] : e;
      startY = touch.clientY;
      isDragging = true;
    };

    const handleMove = (e) => {
      if (!isDragging) return;

      const touch = e.touches ? e.touches[0] : e;
      currentY = touch.clientY;
      const deltaY = currentY - startY;

      // Only allow dragging down (positive deltaY)
      if (deltaY > 0) {
        drawerContent.style.transform = `translateY(${deltaY}px)`;
      }
    };

    const handleEnd = (e) => {
      if (!isDragging) return;

      const deltaY = currentY - startY;

      // If dragged down more than 100px, close the drawer
      if (deltaY > 100) {
        this.closeMobileDrawer();
      }

      // Reset transform
      drawerContent.style.transform = '';
      isDragging = false;
      startY = 0;
      currentY = 0;
    };

    // Make the handle draggable
    const handle = this.mobileDrawer.querySelector('.kit-drawer-handle');
    if (handle) {
      handle.addEventListener('touchstart', handleStart, { passive: true });
      handle.addEventListener('touchmove', handleMove, { passive: true });
      handle.addEventListener('touchend', handleEnd, { passive: true });
    }

    // Make the entire header draggable
    const header = this.mobileDrawer.querySelector('.kit-drawer-header');
    if (header) {
      header.addEventListener('touchstart', handleStart, { passive: true });
      header.addEventListener('touchmove', handleMove, { passive: true });
      header.addEventListener('touchend', handleEnd, { passive: true });
    }

    // Also allow swiping when scrollable area is at the top
    const scrollableArea = this.mobileDrawerItems;
    if (scrollableArea) {
      scrollableArea.addEventListener('touchstart', (e) => {
        // Only allow swipe when at the top of the scrollable area
        if (scrollableArea.scrollTop === 0) {
          handleStart(e);
        }
      }, { passive: true });

      scrollableArea.addEventListener('touchmove', (e) => {
        // Only track movement if we're dragging and at the top
        if (isDragging && scrollableArea.scrollTop === 0) {
          handleMove(e);
        }
      }, { passive: true });

      scrollableArea.addEventListener('touchend', (e) => {
        if (isDragging) {
          handleEnd(e);
        }
      }, { passive: true });
    }
  }

  async postCartAddRequest(data, { includeMiniCartSections = false } = {}) {
    const payload = includeMiniCartSections
      ? { ...data, sections: MOUNT_BUILDER_CART_SECTIONS }
      : data;

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const responseText = await response.text();

    if (!response.ok) {
      let message = `Failed to add item(s) to cart (${response.status})`;
      if (responseText) {
        try {
          const parsedError = JSON.parse(responseText);
          message = parsedError?.description || parsedError?.message || message;
        } catch (parseError) {
          // Keep fallback message when response is not JSON.
        }
      }
      throw new Error(message);
    }

    if (!responseText) return {};

    try {
      return JSON.parse(responseText);
    } catch (parseError) {
      return responseText;
    }
  }

  refreshMiniCart(cartState) {
    if (!cartState || typeof cartState !== 'object' || !cartState.sections) {
      return false;
    }

    const minicart = this.minicart || document.querySelector('mini-cart');
    if (!minicart || typeof minicart.refresh !== 'function') {
      return false;
    }

    this.minicart = minicart;
    minicart.refresh(cartState);
    return true;
  }

  async refreshMiniCartOrSyncCount(cartState) {
    if (!this.refreshMiniCart(cartState)) {
      await this.syncCartItemCount();
    }
  }

  async syncCartItemCount() {
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!response.ok) return;

      const cart = await response.json();
      const itemCount = cart?.item_count ?? 0;

      document.querySelectorAll('[data-items-count]').forEach(el => {
        el.textContent = itemCount;
      });
    } catch (error) {
      console.error('Error syncing cart count:', error);
    }
  }

  async addKitToCart() {
    if (this.kitProducts.length === 0) {
      console.log('No products in kit');
      return;
    }

    // Disable buttons during request
    if (this.sideCartAddBtn) this.sideCartAddBtn.disabled = true;
    if (this.mobileDrawerAddBtn) this.mobileDrawerAddBtn.disabled = true;

    const items = this.kitProducts.map(product => {
      const item = {
        "id": Number(product.id),
        "quantity": product.quantity || 1,
        "properties": {}
      };

      // Add Mount Builder context properties
      for (const [key, value] of Object.entries(this.context.context)) {
        if (value) {
          const skey = "_Mount_Builder_" + key;
          item["properties"][skey] = value;
        }
      }

      return item;
    });

    const data = { items };

    try {
      await this.postCartAddRequest(data);
      await this.syncCartItemCount();

      // Show toast notification on both desktop and mobile
      this.showKitAddedToast(items.length);

      console.log('Kit added to cart:', items.length, 'items');

    } catch (error) {
      console.error('Error adding kit to cart:', error);
      this.showKitErrorToast();
    } finally {
      // Re-enable buttons
      if (this.sideCartAddBtn) this.sideCartAddBtn.disabled = false;
      if (this.mobileDrawerAddBtn) this.mobileDrawerAddBtn.disabled = false;
    }
  }

  showKitAddedToast(itemCount) {
    // Create toast element
    const toast = document.createElement('div');
    toast.className = 'kit-toast kit-toast-success';
    toast.innerHTML = `
      <svg class="kit-toast-icon" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
      </svg>
      <div class="kit-toast-content">
        <div class="kit-toast-title">Added to Cart!</div>
        <div class="kit-toast-message">${itemCount} ${itemCount === 1 ? 'item' : 'items'} added successfully</div>
      </div>
    `;

    document.body.appendChild(toast);

    // Trigger animation
    requestAnimationFrame(() => {
      toast.classList.add('kit-toast-show');
    });

    // Auto-dismiss after 3 seconds
    setTimeout(() => {
      toast.classList.remove('kit-toast-show');
      setTimeout(() => {
        toast.remove();
      }, 300);
    }, 3000);
  }

  showKitErrorToast() {
    // Create toast element
    const toast = document.createElement('div');
    toast.className = 'kit-toast kit-toast-error';
    toast.innerHTML = `
      <svg class="kit-toast-icon" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
      </svg>
      <div class="kit-toast-content">
        <div class="kit-toast-title">Error</div>
        <div class="kit-toast-message">Failed to add kit to cart</div>
      </div>
    `;

    document.body.appendChild(toast);

    // Trigger animation
    requestAnimationFrame(() => {
      toast.classList.add('kit-toast-show');
    });

    // Auto-dismiss after 3 seconds
    setTimeout(() => {
      toast.classList.remove('kit-toast-show');
      setTimeout(() => {
        toast.remove();
      }, 300);
    }, 3000);
  }

  getEventElement(event) {
    if (event?.currentTarget instanceof Element) return event.currentTarget;
    if (event?.target instanceof Element) return event.target;
    if (event?.target?.parentElement instanceof Element) return event.target.parentElement;
    return null;
  }

  addToKitSideCart(event) {
    const eventEl = this.getEventElement(event);
    if (!eventEl) return;

    // Check if it's a modern product card or legacy product tile
    const tile = eventEl.closest("[data-tile]");
    if (!tile) return;

    let product = tile.querySelector("product-tile");

    // If no product-tile element, it's a modern card - get data from the card itself
    if (!product) {
      product = tile; // The modern card has all the data attributes we need
    }

    const productData = this.extractProductData(product);

    // Check if product already exists in kit
    const existingIndex = this.kitProducts.findIndex(p => p.id === productData.id);

    if (existingIndex !== -1) {
      // Product exists - increment quantity
      this.kitProducts[existingIndex].quantity = (this.kitProducts[existingIndex].quantity || 1) + 1;
    } else {
      // New product - add to kit with quantity 1
      productData.quantity = 1;
      this.kitProducts.push(productData);
    }

    // Update the side cart display
    this.renderSideCartItems();
    this.updateSideCartSubtotal();

    // Show visual feedback on the button
    this.showAddToKitFeedback(eventEl);
  }

  showAddToKitFeedback(button) {
    const btn = button.closest('[data-add-to-cart]');
    if (!btn) return;

    const originalText = btn.textContent;
    btn.textContent = 'Added to Kit!';
    btn.style.background = '#ffffff'; // White background
    btn.style.color = '#3D5A80'; // Storm text
    btn.style.border = '1px solid #3D5A80'; // Storm border
    btn.disabled = true;

    setTimeout(() => {
      btn.textContent = originalText;
      btn.style.background = '';
      btn.style.color = '';
      btn.style.border = '';
      btn.disabled = false;
    }, 1000);
  }

  updateProductCardButtonText() {
    // Update all add to cart buttons to say "Add to Kit" when side cart is visible
    if (this.shouldShowSideCart()) {
      const allAddToCartBtns = this.container.querySelectorAll('[data-add-to-cart]');
      allAddToCartBtns.forEach(btn => {
        if (btn.textContent.trim() === 'Add to Cart') {
          btn.textContent = 'Add to Kit';
        }
      });
    }
  }

  async buildResults(data) {
    sessionStorage.removeItem('mountBuilder_activeTab');
    // Only show loading if it's not the initial load
    if (!this.isInitialLoad) {
      this.showLoading();
    }

    try {
      // Check if modern results are enabled
      const enableModernResults = this.getAttribute('data-enable-modern-results') === 'true';
      const sectionId = enableModernResults ? 'api-mb-modern-results' : 'api-mb-results';

      // Fetch and update the container content
      const response = await fetch(`${window.routes.root_url}?section_id=${sectionId}`);
      const text = await response.text();
      const listHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-api-content]').innerHTML;
      this.container.innerHTML = "";
      this.container.innerHTML = listHTML;
      this.container.querySelector('[data-heading]').innerText = data.header_question;

      const tabContent = this.container.querySelector('tab-content');
      if (tabContent) {
        const hasTabs = data.option_2 || data.option_3;

        if (hasTabs) {
          tabContent.classList.remove('w-full', 'w-2/3', 'md:w-2/3');
          tabContent.classList.add('w-full', 'md:w-2/3');
        } else {
          tabContent.classList.remove('w-2/3', 'md:w-2/3');
          tabContent.classList.add('w-full');
        }
      }

      // Helper function to count available products
      const countAvailableProducts = async (products) => {
        if (!products || products.length === 0) return 0;

        let availableCount = products.length;
        for (let i = 0; i < products.length; i++) {
          try {
            const response = await fetch(`${window.routes.root_url}products/${products[i].toLowerCase()}.js`);
            const json = await response.json();
            if (json["available"] === false) {
              availableCount--;
            }
          } catch (e) {
            console.error(e);
          }
        }
        return availableCount;
      };

      // Check availability for each tab
      const tabOneAvailable = data.parts ? await countAvailableProducts(data.parts) : 0;
      const tabTwoAvailable = data.option_2 ? await countAvailableProducts(data.option_2) : 0;
      const tabThreeAvailable = data.option_3 ? await countAvailableProducts(data.option_3) : 0;

      let isComponent = false;
      try {
        isComponent = data.context && data.context.data_set === 'Component';
      } catch (error) {
        console.error('Error checking isComponent:', error);
        isComponent = false;
      }

      if (enableModernResults) {
        // Modern results handling
        await this.buildModernResults(data, tabOneAvailable, tabTwoAvailable, tabThreeAvailable, isComponent);
      } else {
        // Legacy results handling
        await this.buildLegacyResults(data, tabOneAvailable, tabTwoAvailable, tabThreeAvailable, isComponent);
      }

      // console.log('buildResults completed, about to hide loading');

    } catch (error) {
      console.error('Error in buildResults:', error);
    } finally {
      // Only hide loading if it was shown (not during initial load)
      if (!this.isInitialLoad) {
        this.hideLoading();
      }
      // console.log('buildResults finally block completed');
    }
  }

  async buildModernResults(data, tabOneAvailable, tabTwoAvailable, tabThreeAvailable, isComponent) {
    // Helper function to determine container classes based on product count
    const getContainerClasses = (count) => {
      if (!count || count === 0) {
        return 'grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6 max-w-7xl mx-auto';
      }

      // For 1-3 cards on desktop: use flexbox to center them
      // For 4+ cards on desktop: use regular 5-column grid
      // Mobile/tablet always use grid (unchanged)
      if (count <= 3) {
        return 'grid grid-cols-2 md:grid-cols-3 lg:flex lg:flex-wrap lg:justify-center gap-4 md:gap-6 max-w-7xl mx-auto';
      }

      return 'grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6 max-w-7xl mx-auto';
    };

    // Check if we have multiple tabs - FIXED LOGIC
    const hasOption2 = data.option_2 && data.option_2.length > 0;
    const hasOption3 = data.option_3 && data.option_3.length > 0;
    const hasMultipleTabs = hasOption2 || hasOption3;

    // CHECK IF WE SHOULD SHOW BUNDLE HEADER
    const showBundleHeader = this.shouldShowBundleHeader(data);

    // INJECT BUNDLE HEADER IF NEEDED (before any other content manipulation)
    if (showBundleHeader) {
      const heading = this.container.querySelector('[data-heading]');
      if (heading) {
        const parent = heading.parentElement;

        // Create a wrapper div for flex layout
        const wrapper = document.createElement('div');
        wrapper.className = 'bundle-heading-wrapper';

        // Move heading into wrapper
        parent.insertBefore(wrapper, heading);
        wrapper.appendChild(heading);

        // Add bundle header to wrapper
        wrapper.insertAdjacentHTML('beforeend', this.createBundleHeaderHTML());
      }
    }

    // Use manageClasses for non-button elements - UPDATED TO HIDE BUNDLE BUTTONS
    this.manageClasses([
      { selector: '#tabs-option-1 [data-add-bundle]',    class: 'hidden', action: (tabOneAvailable <= 1 || isComponent || showBundleHeader) ? 'add' : 'remove' },
      { selector: '#tabs-option-2 [data-add-bundle]',    class: 'hidden', action: (tabTwoAvailable <= 1 || isComponent || showBundleHeader) ? 'add' : 'remove' },
      { selector: '#tabs-option-3 [data-add-bundle]',    class: 'hidden', action: (tabThreeAvailable <= 1 || isComponent || showBundleHeader) ? 'add' : 'remove' },
      // Hide mobile dropdown when only one option
      { selector: '[data-mobile-tab-selector]',          class: 'hidden', action: !hasMultipleTabs ? 'add' : 'remove' },
      { selector: '[data-mobile-tab-selector] + svg',    class: 'hidden', action: !hasMultipleTabs ? 'add' : 'remove' },
      // Hide desktop tab navigation when only one option
      { selector: 'nav[aria-label="Tab options"]',       class: 'hidden', action: !hasMultipleTabs ? 'add' : 'remove' },
      // Handle individual tab visibility when tabs are shown
      { selector: '[data-toggle="option-2"]',            class: 'hidden', action: (!hasOption2 && hasMultipleTabs) ? 'add' : 'remove' },
      { selector: '[data-toggle="option-3"]',            class: 'hidden', action: (!hasOption3 && hasMultipleTabs) ? 'add' : 'remove' },
      // Handle mobile dropdown options when tabs are shown
      { selector: '[data-mobile-tab-selector] option[value="option-2"]', class: 'hidden', action: (!hasOption2 && hasMultipleTabs) ? 'add' : 'remove' },
      { selector: '[data-mobile-tab-selector] option[value="option-3"]', class: 'hidden', action: (!hasOption3 && hasMultipleTabs) ? 'add' : 'remove' },
      // Set grid classes for content areas
      { selector: '#tabs-option-1 [data-inner-content]', class: getContainerClasses(data.parts?.length), action: 'add' },
      { selector: '#tabs-option-2 [data-inner-content]', class: getContainerClasses(data.option_2?.length), action: 'add' },
      { selector: '#tabs-option-3 [data-inner-content]', class: getContainerClasses(data.option_3?.length), action: 'add' }
    ]);

    const productTileData = [
      { data: data.parts,    selector: '#tabs-option-1 [data-inner-content]' },
      { data: data.option_2, selector: '#tabs-option-2 [data-inner-content]' },
      { data: data.option_3, selector: '#tabs-option-3 [data-inner-content]' }
    ];

    // Load modern product tiles with callbacks
    const loadPromises = productTileData.map(item => {
      if (item.data && item.data.length > 0) {
        return new Promise(resolve => {
          const callback = () => {
            // No complex grid column adjustments needed
            resolve();
          };
          this.loadModernProductTile(item.data, item.selector, callback);
        });
      }
      return Promise.resolve();
    });

    // Wait for all product tiles to load
    await Promise.all(loadPromises);

    // Only set up tab functionality if we have multiple tabs
    if (hasMultipleTabs) {
      this.setupModernTabs();
    }

    // Add bundle button event listeners (only if bundle header is NOT shown)
    if (!showBundleHeader) {
      const addBundleButtons = [...this.container.querySelectorAll('[data-add-bundle]')];
      addBundleButtons.forEach(button => button.addEventListener('click', this.bundleProducts.bind(this)));
    }

    // Handle accessories
    if (data.accessories && data.accessories.length > 0) {
      await this.loadModernAccessories(data.accessories);
    }

    this.manageClasses([
      { selector: '#result-list', class: 'hidden', action: 'remove' }
    ]);

    if (showBundleHeader) {
      // Add a delay to ensure DOM is fully updated with price data
      setTimeout(() => {
        this.setupBundleHeaderListeners();
        // Update subtotal after a short delay
        setTimeout(() => {
          this.updateBundleSubtotal();
        }, 100);
      }, 100);
    }

    if (this.enableSideCart) {
      setTimeout(() => {
        this.updateSideCart();
      }, 100);
    }
  }

  shouldShowBundleHeader(data) {
    const enableBundleHeader = this.getAttribute('data-enable-bundle-header') === 'true';
    if (!enableBundleHeader) return false;

    const dataSet = data.context?.data_set || '';
    return dataSet === 'Push-to-talk Kits' || dataSet === 'Device';
  }

  createBundleHeaderHTML() {
    return `
      <div id="bundle-header" class="bundle-header">
        <!-- Mobile Bundle Bar -->
        <div class="mobile-bundle-bar">
          <div class="text-left">
            <span id="bundle-subtotal-mobile" class="bundle-subtotal">$0.00</span>
          </div>
          <div class="flex items-center space-x-2">
            <button type="button" id="bundle-add-cart-btn-mobile" class="bundle-add-btn">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1 stroke-white">
                <path d="M6.29977 5H21L19 12H7.37671M20 16H8L6 3H3M9 20C9 20.5523 8.55228 21 8 21C7.44772 21 7 20.5523 7 20C7 19.4477 7.44772 19 8 19C8.55228 19 9 19.4477 9 20ZM20 20C20 20.5523 19.5523 21 19 21C18.4477 21 18 20.5523 18 20C18 19.4477 18.4477 19 19 19C19.5523 19 20 19.4477 20 20Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Add Kit to Cart
            </button>
          </div>
        </div>

        <!-- Desktop Bundle Bar -->
        <div class="desktop-bundle-bar">
          <div class="flex items-center gap-3">
            <p class="text-base font-semibold whitespace-nowrap">Subtotal: <span id="bundle-subtotal-desktop" class="bundle-subtotal">$0.00</span></p>
            <button type="button" id="bundle-add-cart-btn-desktop" class="bundle-add-btn">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1 stroke-white">
                <path d="M6.29977 5H21L19 12H7.37671M20 16H8L6 3H3M9 20C9 20.5523 8.55228 21 8 21C7.44772 21 7 20.5523 7 20C7 19.4477 7.44772 19 8 19C8.55228 19 9 19.4477 9 20ZM20 20C20 20.5523 19.5523 21 19 21C18.4477 21 18 20.5523 18 20C18 19.4477 18.4477 19 19 19C19.5523 19 20 19.4477 20 20Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Add Kit to Cart
            </button>
          </div>
        </div>
      </div>
    `;
  }

  updateBundleSubtotal() {
    // Get all product cards that are not accessories
    const mainProducts = this.getAllMainProducts();

    // console.log('Updating bundle subtotal. Found products:', mainProducts.length);

    let subtotal = 0;
    mainProducts.forEach(product => {
      const price = parseFloat(product.dataset.productPrice || product.dataset.price || 0);
      // console.log('Product price:', price, 'from element:', product);
      if (!isNaN(price)) {
        subtotal += price;
      }
    });

    // console.log('Total subtotal:', subtotal);

    // Format as currency
    const formattedSubtotal = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(subtotal);

    // Update both mobile and desktop displays
    const mobileSubtotal = document.getElementById('bundle-subtotal-mobile');
    const desktopSubtotal = document.getElementById('bundle-subtotal-desktop');

    if (mobileSubtotal) mobileSubtotal.textContent = formattedSubtotal;
    if (desktopSubtotal) desktopSubtotal.textContent = formattedSubtotal;
  }

  getAllMainProducts() {
    const products = [];

    // Get only the CURRENTLY VISIBLE tab pane (not hidden tabs)
    const visibleTabPanes = this.container.querySelectorAll('.tab-pane:not(.hidden)');

    visibleTabPanes.forEach(pane => {
      // Skip if this is the accessories section
      if (pane.id === 'accessories-grid' || pane.closest('#accessories-grid')) {
        return;
      }

      // For modern cards
      const modernCards = pane.querySelectorAll('.modern-product-card');
      modernCards.forEach(card => {
        // Skip accessories marked with data attribute
        if (card.dataset.accessory || card.closest('#accessories-grid')) {
          return;
        }
        // Only include available products
        if (card.dataset.available !== 'false') {
          products.push(card);
        }
      });

      // For legacy product tiles
      const legacyTiles = pane.querySelectorAll('product-tile');
      legacyTiles.forEach(tile => {
        if (tile.dataset.available !== 'false') {
          products.push(tile);
        }
      });
    });

    return products;
  }

  async handleBundleAddToCart() {
    const mainProducts = this.getAllMainProducts();

    if (mainProducts.length === 0) {
      console.log('No available products to add');
      return;
    }

    const items = [];
    mainProducts.forEach(product => {
      const variantId = product.dataset.id || product.dataset.variantId;
      if (variantId) {
        const item = {
          "id": Number(variantId),
          "quantity": 1,
          "properties": {}
        };

        // Add Mount Builder context properties
        for (const [key, value] of Object.entries(this.context.context)) {
          if (value) {
            const skey = "_Mount_Builder_" + key;
            item["properties"][skey] = value;
          }
        }

        items.push(item);
      }
    });

    if (items.length === 0) {
      console.log('No valid products to add');
      return;
    }

    const data = { items };

    try {
      // Disable buttons during request
      const buttons = document.querySelectorAll('[id^="bundle-add-cart-btn"]');
      buttons.forEach(btn => btn.disabled = true);

      const cartState = await this.postCartAddRequest(data, { includeMiniCartSections: true });
      await this.refreshMiniCartOrSyncCount(cartState);
      console.log('Bundle added to cart:', items.length, 'items');

    } catch (error) {
      console.error('Error adding bundle to cart:', error);
    } finally {
      // Re-enable buttons
      const buttons = document.querySelectorAll('[id^="bundle-add-cart-btn"]');
      buttons.forEach(btn => btn.disabled = false);
    }
  }

  // Add this method to setup bundle header event listeners
  setupBundleHeaderListeners() {
    // Add to cart buttons
    const addCartBtnMobile = document.getElementById('bundle-add-cart-btn-mobile');
    const addCartBtnDesktop = document.getElementById('bundle-add-cart-btn-desktop');

    if (addCartBtnMobile) {
      addCartBtnMobile.addEventListener('click', () => this.handleBundleAddToCart());
    }
    if (addCartBtnDesktop) {
      addCartBtnDesktop.addEventListener('click', () => this.handleBundleAddToCart());
    }

    // Update subtotal initially
    this.updateBundleSubtotal();
  }

  setupModernTabs() {
    const tabLinks = this.container.querySelectorAll('[data-toggle]');
    const tabPanes = this.container.querySelectorAll('.tab-pane');
    const mobileSelector = this.container.querySelector('[data-mobile-tab-selector]');

    // Store active tab in session storage instead of URL
    const storageKey = 'mountBuilder_activeTab';

    const activateTab = (targetId, updateStorage = true) => {
      // Update all desktop tabs
      tabLinks.forEach(link => {
        const spans = link.querySelectorAll('span');
        const indicator = spans[spans.length - 1];

        if (link.getAttribute('data-toggle') === targetId) {
          link.setAttribute('aria-selected', 'true');
          link.style.color = 'rgb(17, 24, 39)';
          if (indicator && indicator.hasAttribute('aria-hidden')) {
            indicator.style.backgroundColor = '#3D5A80';
          }
        } else {
          link.setAttribute('aria-selected', 'false');
          link.style.color = 'rgb(107, 114, 128)';
          if (indicator && indicator.hasAttribute('aria-hidden')) {
            indicator.style.backgroundColor = 'transparent';
          }
        }
      });


      if (this.enableSideCart && this.shouldShowSideCart()) {
        setTimeout(() => {
          this.updateSideCart();
        }, 50);
      }

      if (this.shouldShowBundleHeader(this.context)) {
        setTimeout(() => {
          this.updateBundleSubtotal();
        }, 50);
      }

      // Show/hide content panes
      tabPanes.forEach(pane => {
        if (pane.getAttribute('data-content') === targetId) {
          pane.classList.remove('hidden');
        } else {
          pane.classList.add('hidden');
        }
      });

      // Update mobile selector
      if (mobileSelector) {
        mobileSelector.value = targetId;
      }

      // Store in session storage instead of URL
      if (updateStorage) {
        sessionStorage.setItem(storageKey, targetId);
      }

      // UPDATE SUBTOTAL WHEN TAB CHANGES
      if (this.shouldShowBundleHeader(this.context)) {
        // Small delay to ensure DOM is updated
        setTimeout(() => {
          this.updateBundleSubtotal();
        }, 50);
      }
    };

    // Desktop tab click handlers
    tabLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation(); // Prevent hash from being added to URL
        const targetId = link.getAttribute('data-toggle');
        activateTab(targetId);
      });
    });

    // Mobile selector change handler
    if (mobileSelector) {
      mobileSelector.addEventListener('change', () => {
        const targetId = mobileSelector.value;
        activateTab(targetId);
      });
    }

    // Check for refresh scenario with cleaned hash
    const refreshTab = sessionStorage.getItem('mountBuilder_refreshTab');
    if (refreshTab && this.container.querySelector(`[data-toggle="${refreshTab}"]`)) {
      // Activate the tab that was in the URL before refresh
      activateTab(refreshTab, false);
      // Clear the refresh flag
      sessionStorage.removeItem('mountBuilder_refreshTab');
    } else {
      // Check session storage for previously active tab
      const storedTab = sessionStorage.getItem(storageKey);
      if (storedTab && this.container.querySelector(`[data-toggle="${storedTab}"]`)) {
        activateTab(storedTab, false);
      } else {
        // Initialize first visible tab as active
        const activeTab = Array.from(tabLinks).find(link => link.getAttribute('aria-selected') === 'true');
        if (!activeTab) {
          const firstVisibleTab = Array.from(tabLinks).find(link => !link.classList.contains('hidden'));
          if (firstVisibleTab) {
            const firstTabId = firstVisibleTab.getAttribute('data-toggle');
            activateTab(firstTabId);
          } else {
            activateTab('option-1');
          }
        }
      }
    }
  }

  async buildLegacyResults(data, tabOneAvailable, tabTwoAvailable, tabThreeAvailable, isComponent) {
    // Original legacy code logic here
    const gridClassMap = {
      1: 'lg:grid-cols-3 md:grid-cols-3 grid-cols-1',
      2: 'lg:grid-cols-4 md:grid-cols-2 grid-cols-2',
      3: 'lg:grid-cols-3 md:grid-cols-3 grid-cols-2',
      4: 'lg:grid-cols-4 md:grid-cols-2 grid-cols-2',
      5: 'lg:grid-cols-5 md:grid-cols-3 grid-cols-2',
      6: 'lg:grid-cols-6 md:grid-cols-3 grid-cols-2',
      7: 'lg:grid-cols-6 md:grid-cols-4 grid-cols-2',
      8: 'lg:grid-cols-6 md:grid-cols-4 grid-cols-2',
      9: 'lg:grid-cols-6 md:grid-cols-3 grid-cols-2',
      10: 'lg:grid-cols-6 md:grid-cols-4 grid-cols-2',
      11: 'lg:grid-cols-6 md:grid-cols-4 grid-cols-2',
      12: 'lg:grid-cols-6 md:grid-cols-4 grid-cols-2'
    };

    const getMaxWidthClass = (count) => {
      if (!count) return 'max-w-8xl';
      if (count <= 2) return 'max-w-6xl';
      if (count <= 4) return 'max-w-7xl';
      return 'max-w-8xl';
    };

    // CHECK IF WE SHOULD SHOW BUNDLE HEADER
    const showBundleHeader = this.shouldShowBundleHeader(data);

    // INJECT BUNDLE HEADER IF NEEDED (before any other content manipulation)
    if (showBundleHeader) {
      const tabContent = this.container.querySelector('.tab-content');
      if (tabContent) {
        tabContent.insertAdjacentHTML('afterbegin', this.createBundleHeaderHTML());
      }
    }

    // UPDATED TO HIDE BUNDLE BUTTONS WHEN BUNDLE HEADER IS SHOWN
    this.manageClasses([
      { selector: '#tabs-option-1 [data-add-bundle]',    class: 'hidden', action: (tabOneAvailable <= 1 || isComponent || showBundleHeader) ? 'add' : 'remove' },
      { selector: '#tabs-option-2 [data-add-bundle]',    class: 'hidden', action: (tabTwoAvailable <= 1 || isComponent || showBundleHeader) ? 'add' : 'remove' },
      { selector: '#tabs-option-3 [data-add-bundle]',    class: 'hidden', action: (tabThreeAvailable <= 1 || isComponent || showBundleHeader) ? 'add' : 'remove' },
      { selector: '.mobile-toggle',                      class: 'hidden', action: (!data.option_2 && !data.option_3) ? 'add' : 'remove' },
      { selector: '.mobile-toggle ul li:last-child',     class: 'hidden', action: !data.option_3 ? 'add' : 'remove' },
      { selector: '[data-add-accessory]',                class: 'hidden', action: !(data.accessories && data.accessories.length > 0) ? 'add' : 'remove' },
      { selector: '#tabs-option-1 [data-inner-content]', class: data.parts    ? `${gridClassMap[data.parts.length] || 'lg:grid-cols-6 md:grid-cols-3 grid-cols-2'} ${getMaxWidthClass(data.parts.length)} mx-auto` : 'lg:grid-cols-6 md:grid-cols-4 grid-cols-2 max-w-8xl mx-auto', action: 'add' },
      { selector: '#tabs-option-2 [data-inner-content]', class: data.option_2 ? `${gridClassMap[data.option_2.length] || 'lg:grid-cols-6 md:grid-cols-3 grid-cols-2'} ${getMaxWidthClass(data.option_2.length)} mx-auto` : 'lg:grid-cols-6 md:grid-cols-4 grid-cols-2 max-w-8xl mx-auto', action: 'add' },
      { selector: '#tabs-option-3 [data-inner-content]', class: data.option_3 ? `${gridClassMap[data.option_3.length] || 'lg:grid-cols-6 md:grid-cols-3 grid-cols-2'} ${getMaxWidthClass(data.option_3.length)} mx-auto` : 'lg:grid-cols-6 md:grid-cols-4 grid-cols-2 max-w-8xl mx-auto', action: 'add' }
    ]);

    const productTileData = [
      { data: data.parts,    selector: '#tabs-option-1 [data-inner-content]' },
      { data: data.option_2, selector: '#tabs-option-2 [data-inner-content]' },
      { data: data.option_3, selector: '#tabs-option-3 [data-inner-content]' }
    ];

    const applyGridColumnStyle = (tabSelector, itemCount) => {
      const adjustStyle = () => {
        let element = this.querySelector(`${tabSelector} [data-tile]`);
        if (!element) {
          console.error('Element not found:', tabSelector);
          return;
        }

        element.style.cssText = '';

        if (window.innerWidth >= 1024) {
          if (itemCount === 1 || itemCount === 2) {
            element.style.cssText = 'grid-column-start: 2';
          } else if (itemCount === 5 || itemCount === 6) {
            element.style.cssText = 'grid-column-start: auto';
          } else {
            element.style.cssText = 'grid-column-start: auto';
          }
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
          if (itemCount === 1) {
            element.style.cssText = 'grid-column-start: 2';
          } else if (itemCount === 5 || itemCount === 6) {
            element.style.cssText = 'grid-column-start: auto';
          } else {
            element.style.cssText = 'grid-column-start: auto';
          }
        } else {
          element.style.cssText = 'grid-column-start: auto';
        }
      };

      window.addEventListener('resize', adjustStyle);
      adjustStyle();

      this.manageClasses([
        { selector: '#result-list', class: 'hidden', action: 'remove' }
      ]);
    };

    // Load product tiles with callbacks
    const loadPromises = productTileData.map(item => {
      if (item.data && item.data.length > 0) {
        return new Promise(resolve => {
          const callback = () => {
            applyGridColumnStyle(item.selector, item.data.length);
            resolve();
          };
          this.loadProductTile(item.data, item.selector, callback);
        });
      }
      return Promise.resolve();
    });

    // Wait for all product tiles to load
    await Promise.all(loadPromises);

    // Add bundle button event listeners (only if bundle header is NOT shown)
    if (!showBundleHeader) {
      const addBundleButtons = [...this.container.querySelectorAll('[data-add-bundle]')];
      addBundleButtons.forEach(button => button.addEventListener('click', this.bundleProducts.bind(this)));
    }

    const accessoryBtn = this.container.querySelector('[data-add-accessory]');
    if (data.accessories && data.accessories.length > 0) {
      accessoryBtn.addEventListener('click', this.loadAccessories.bind(this));
    }

    // SETUP BUNDLE HEADER LISTENERS IF SHOWN
    if (showBundleHeader) {
      this.setupBundleHeaderListeners();
    }
  }

  async loadModernProductTile(options, selector, callback) {
    if (options && options.length > 0) {
      try {
        // Check if styles have already been injected
        if (!document.getElementById('modern-product-card-styles')) {
          // Fetch one product just to get the styles
          const styleResponse = await fetch(`${window.routes.root_url}products/${options[0].toLowerCase()}/?section_id=api-modern-product-tile`);
          const styleText = await styleResponse.text();
          const styleDoc = new DOMParser().parseFromString(styleText, 'text/html');
          const styleTag = styleDoc.querySelector('style');

          if (styleTag) {
            const newStyleTag = document.createElement('style');
            newStyleTag.id = 'modern-product-card-styles';
            newStyleTag.textContent = styleTag.textContent;
            document.head.appendChild(newStyleTag);
          }
        }

        // Updated alignment fixes with proper mobile layout and increased title height
        if (!document.getElementById('modern-card-alignment-fixes')) {
          const alignmentFixes = document.createElement('style');
          alignmentFixes.id = 'modern-card-alignment-fixes';
          alignmentFixes.textContent = `
            /* Tablet and Desktop: Base card styling */
            @media (min-width: 769px) {
              .modern-product-card {
                display: flex !important;
                flex-direction: column !important;
                height: 100% !important;
                min-height: 420px !important;
                position: relative !important;
                overflow: hidden !important;
              }

              .modern-product-card .card-image-container {
                position: relative !important;
                z-index: 1 !important;
              }

              .modern-product-card .card-content {
                flex: 1 !important;
                display: flex !important;
                flex-direction: column !important;
                position: relative !important;
                z-index: 2 !important;
                background: white !important;
              }

              .modern-product-card .product-title {
                min-height: 3.75rem !important;
                max-height: 3.75rem !important;
                -webkit-line-clamp: 3 !important;
                line-height: 1.25rem !important;
                overflow: hidden !important;
                text-overflow: ellipsis !important;
              }

              .modern-product-card .product-price {
                margin-bottom: auto !important;
              }

              .modern-product-card .add-to-cart-btn {
                margin-top: auto !important;
                flex-shrink: 0 !important;
              }

              /* Ensure preview eye stays in correct position */
              .modern-product-card .preview-eye-icon {
                position: absolute !important;
                top: 0 !important;
                left: 0 !important;
                right: 0 !important;
                bottom: 0 !important;
                z-index: 10 !important;
              }
            }

            /* Desktop only: Fixed card width for flexbox centering */
            @media (min-width: 1024px) {
              .modern-product-card {
                width: 220px !important;
                flex-shrink: 0 !important;
              }
            }

            /* Mobile: Mini card versions in 2x2 grid */
            @media (max-width: 768px) {
              .modern-product-card {
                display: flex !important;
                flex-direction: column !important;
                height: 100% !important;
                min-height: 280px !important;
                position: relative !important;
                overflow: hidden !important;
              }

              .modern-product-card.mobile-layout {
                display: flex !important;
                flex-direction: column !important;
              }

              .modern-product-card > .hidden.md\\:block {
                display: none !important;
              }

              .modern-product-card > .block.md\\:hidden {
                display: flex !important;
                flex-direction: column !important;
                height: 100% !important;
              }

              .modern-product-card .flex.flex-row {
                flex-direction: column !important;
                flex: 1 !important;
                display: flex !important;
              }

              .modern-product-card .w-1\\/3 {
                width: 100% !important;
                height: 150px !important;
                flex-shrink: 0 !important;
                position: relative !important;
                z-index: 1 !important;
              }

              .modern-product-card .w-2\\/3 {
                width: 100% !important;
                flex: 1 !important;
                display: flex !important;
                flex-direction: column !important;
                border-left: none !important;
                border-top: none !important;
                position: relative !important;
                z-index: 2 !important;
                background: white !important;
                padding: 0.5rem !important;
                gap: 0.25rem !important;
              }

              .modern-product-card .product-title {
                font-size: 0.75rem !important;
                line-height: 0.95rem !important;
                min-height: 2.85rem !important;
                max-height: 2.85rem !important;
                -webkit-line-clamp: 3 !important;
                overflow: hidden !important;
                text-overflow: ellipsis !important;
                margin-bottom: 0 !important;
                flex-shrink: 0 !important;
              }

              .modern-product-card .product-sku {
                font-size: 0.625rem !important;
                margin-bottom: 0 !important;
                flex-shrink: 0 !important;
              }

              .modern-product-card .product-price {
                font-size: 0.75rem !important;
                margin-bottom: 0 !important;
                flex-shrink: 0 !important;
              }

              .modern-product-card .add-to-cart-btn {
                font-size: 0.75rem !important;
                padding: 0.375rem 0.5rem !important;
                min-height: 2rem !important;
                margin-top: 0.25rem !important;
                flex-shrink: 0 !important;
              }

              .modern-product-card .checkmark-container {
                top: 0.25rem !important;
                right: 0.25rem !important;
              }

              .modern-product-card .absolute.top-8.right-2 {
                top: 0.5rem !important;
                right: 0.5rem !important;
                z-index: 20 !important;
              }

              .modern-product-card .w-8.h-8 {
                width: 1.5rem !important;
                height: 1.5rem !important;
              }

              .modern-product-card .w-5.h-5 {
                width: 1rem !important;
                height: 1rem !important;
              }

              .mobile-coming-soon-badge {
                font-size: 0.5rem !important;
                padding: 0.125rem 0.375rem !important;
              }
            }

            /* Coming Soon button styling */
            .modern-product-card .coming-soon-btn {
              background: #6b7280 !important;
              color: white !important;
              cursor: pointer !important;
              border: 1px solid #4b5563 !important;
            }

            .modern-product-card .coming-soon-btn:hover {
              background: #4b5563 !important;
              color: white !important;
              border: 1px solid #374151 !important;
            }

            /* Unavailable product fixes */
            .modern-product-card.unavailable-product {
              opacity: 0.9 !important;
            }

            .coming-soon-overlay {
              background: rgba(255, 255, 255, 0.6) !important;
              backdrop-filter: blur(1px) !important;
            }

            .coming-soon-badge {
              background: linear-gradient(45deg, #9ca3af, #6b7280) !important;
              color: white !important;
              font-weight: 600 !important;
              text-transform: uppercase !important;
              opacity: 0.9 !important;
            }
          `;
          document.head.appendChild(alignmentFixes);
        }

        // Now fetch all products
        const fetchPromises = options.map(option =>
          fetch(`${window.routes.root_url}products/${option.toLowerCase()}/?section_id=api-modern-product-tile`).then(response => response.text())
        );
        const responses = await Promise.all(fetchPromises);
        const productTiles = responses.map(text =>
          new DOMParser().parseFromString(text, 'text/html').querySelector('[data-api-content]').innerHTML
        ).join('');

        // Update the innerHTML of the selector with all product tiles
        this.container.querySelector(selector).innerHTML = productTiles;

        // Add event listeners to modern cards
        const modernCards = [...this.container.querySelectorAll(`${selector} .modern-product-card`)];
        modernCards.forEach(card => {
          // Check if product is unavailable and add class
          const isUnavailable = card.dataset.available === 'false';
          if (isUnavailable) {
            card.classList.add('unavailable-product');
          }

          // Add to cart listeners - need to get ALL buttons (desktop and mobile)
          const addToCartBtns = card.querySelectorAll('[data-add-to-cart]');
          addToCartBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              // Route to kit side cart if visible, otherwise add to cart directly
              if (this.shouldShowSideCart()) {
                this.addToKitSideCart(e);
              } else {
                this.addToCartSingle(e);
              }
            });
          });

          // Notify Me button for coming soon products
          const notifyBtns = card.querySelectorAll('[data-notify-me]');
          notifyBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              console.log('Notify me clicked for product:', btn.dataset.productId);
            });
          });

          // Preview eye listeners - need to get ALL preview buttons
          const previewBtns = card.querySelectorAll('.preview-eye-btn');
          previewBtns.forEach(btn => {
            btn.addEventListener('click', e => {
              e.preventDefault();
              e.stopPropagation();
              this.handlePreviewClick(e);
            });
          });

          // Make image containers clickable too
          const imageContainers = card.querySelectorAll('.card-image-container');
          imageContainers.forEach(container => {
            container.style.cursor = 'pointer';
            container.addEventListener('click', e => {
              e.preventDefault();
              e.stopPropagation();
              this.handlePreviewClick(e);
            });
          });
        });

        // Update button text if side cart is visible
        this.updateProductCardButtonText();

        // Call the callback function after the product tiles are loaded
        if (callback && typeof callback === 'function') {
          callback();
        }
      } catch (e) {
        console.error('Error loading modern product tiles:', e);
      }
    }
  }

  async loadModernAccessories(accessories) {
    // Create accessories section HTML
    const accessoriesHTML = `
      <div class="mt-12 pt-8">
        <h3 class="text-xl font-bold text-gray-900 mb-6">Recommended Add-Ons</h3>
        <div id="accessories-grid" class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6 max-w-7xl mx-auto place-content-center">
          <!-- Accessories will be loaded here -->
        </div>
      </div>
    `;

    // Find the tab content container and append accessories
    const tabContentContainer = this.container.querySelector('.tab-content');
    if (tabContentContainer) {
      tabContentContainer.insertAdjacentHTML('beforeend', accessoriesHTML);

      // Load the accessory product tiles
      try {
        const fetchPromises = accessories.map(accessory =>
          fetch(`${window.routes.root_url}products/${accessory.toLowerCase()}/?section_id=api-modern-product-tile`).then(response => response.text())
        );
        const responses = await Promise.all(fetchPromises);
        const accessoryTiles = responses.map(text =>
          new DOMParser().parseFromString(text, 'text/html').querySelector('[data-api-content]').innerHTML
        ).join('');

        // Insert accessories into the grid
        this.container.querySelector('#accessories-grid').innerHTML = accessoryTiles;

        // Add event listeners to accessory cards
        const accessoryCards = [...this.container.querySelectorAll('#accessories-grid .modern-product-card')];
        accessoryCards.forEach(card => {
          // Add to cart listeners - need to get ALL buttons (desktop and mobile)
          const addToCartBtns = card.querySelectorAll('[data-add-to-cart]');
          addToCartBtns.forEach(btn => {
            btn.addEventListener('click', e => {
              e.preventDefault();
              e.stopPropagation();
              // Route to kit side cart if visible, otherwise add to cart directly
              if (this.shouldShowSideCart()) {
                this.addToKitSideCart(e);
              } else {
                this.addToCartSingle(e);
              }
            });
          });

          // Preview eye listeners - need to get ALL preview buttons
          const previewBtns = card.querySelectorAll('.preview-eye-btn');
          previewBtns.forEach(btn => {
            btn.addEventListener('click', e => {
              e.preventDefault();
              e.stopPropagation();
              this.handlePreviewClick(e);
            });
          });

          // Make image containers clickable too
          const imageContainers = card.querySelectorAll('.card-image-container');
          imageContainers.forEach(container => {
            container.style.cursor = 'pointer';
            container.addEventListener('click', e => {
              e.preventDefault();
              e.stopPropagation();
              this.handlePreviewClick(e);
            });
          });
        });

        // Update button text if side cart is visible
        this.updateProductCardButtonText();
      } catch (e) {
        console.error('Error loading accessories:', e);
      }
    }
  }

  handlePreviewClick(event) {
      event.preventDefault();
      event.stopPropagation();

      // Try to get product handle from preview button first, then from card
      const previewBtn = event.target.closest('.preview-eye-btn');
      const card = event.target.closest('.modern-product-card');
      const productHandle = previewBtn?.dataset.productHandle || card?.dataset.productHandle;

      if (productHandle) {
          // Use the new modal instead of window.open
          this.previewModal.open(productHandle);
      }
  }

  applyModernGridColumnStyle(tabSelector, itemCount) {
    // Modern grid styling doesn't need complex column adjustments
    // The CSS grid system handles this automatically
    this.manageClasses([
      { selector: '#result-list', class: 'hidden', action: 'remove' }
    ]);
  }

  async loadAccessories(){
    this.context.accessories_active = true;
    await fetch(`${window.routes.root_url}?section_id=api-mb-accessories`)
      .then((response) => response.text())
      .then((text) => {
        const listHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-api-content]').innerHTML;
        this.container.innerHTML = "";
        this.container.innerHTML = listHTML;
        this.container.querySelector('[data-heading]').innerText = "We recommend these accessories for your kit.";
      })
      .catch((e) => {
        console.error(e);
      });

    if(this.context.accessories && this.context.accessories.length > 0){
      // Add the max-width constraint here
      const resultList = this.container.querySelector('#result-list');
      if (resultList) {
        // Add max-width and center the container
        resultList.classList.add('max-w-6xl', 'mx-auto');

        // Also add grid classes based on number of accessories
        const gridClassMap = {
          1: 'lg:grid-cols-3 md:grid-cols-3 grid-cols-1',
          2: 'lg:grid-cols-4 md:grid-cols-2 grid-cols-2',
          3: 'lg:grid-cols-3 md:grid-cols-3 grid-cols-2',
          4: 'lg:grid-cols-4 md:grid-cols-2 grid-cols-2',
          5: 'lg:grid-cols-5 md:grid-cols-3 grid-cols-2',
          6: 'lg:grid-cols-6 md:grid-cols-3 grid-cols-2',
          7: 'lg:grid-cols-6 md:grid-cols-4 grid-cols-2',
          8: 'lg:grid-cols-6 md:grid-cols-4 grid-cols-2',
          9: 'lg:grid-cols-6 md:grid-cols-3 grid-cols-2',
          10: 'lg:grid-cols-6 md:grid-cols-4 grid-cols-2',
          11: 'lg:grid-cols-6 md:grid-cols-4 grid-cols-2',
          12: 'lg:grid-cols-6 md:grid-cols-4 grid-cols-2'
        };

        const accessoryCount = this.context.accessories.length;
        const gridClasses = gridClassMap[accessoryCount] || 'lg:grid-cols-6 md:grid-cols-4 grid-cols-2';

        // Add grid classes to result-list
        resultList.className = `grid gap-4 ${gridClasses} max-w-6xl mx-auto`;
      }

      this.loadProductTile(this.context.accessories, '#result-list');
    }
    window.scrollTo(0, 0);
  }

  async navigateToContext(newContext) {
    // Clean tab parameters before navigating
    this.cleanTabParameters();

    // Clear tab state when navigating away from results
    sessionStorage.removeItem('mountBuilder_activeTab');
    sessionStorage.removeItem('mountBuilder_refreshTab');

    if (newContext === '{}' || (typeof newContext === 'object' && Object.keys(newContext).length === 0)) {
      this.toggleButtonVisibility('[data-all-results]', false);
      this.toggleButtonVisibility('[data-show-end-result-collection]', false);
    }

    if (typeof newContext === 'string' && this.isValidJSON(newContext)) {
      newContext = JSON.parse(newContext);
    }

    this.context.context = newContext;
    await this.sendRequest(this.context.context);

    if (this.context) {
      this.buildStep();

      if (this.enableSideCart && this.context && this.context.page_type !== 'results') {
        this.hideSideCart();
        this.showHelpModalFooter();
      }
    }
  }

  // Helper function to check if a string is valid JSON
  isValidJSON(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }

  async bundleProducts(event){
      const contentContainer = event.target.closest("[data-content]");

      // First try to find modern product cards
      let products = contentContainer.querySelectorAll(".modern-product-card");

      // If no modern cards found, look for legacy product-tile elements
      if (!products || products.length === 0) {
        products = contentContainer.querySelectorAll("product-tile");
      }

      if(products && products.length > 0){
        let items =  [];
        for (let i = 0; i < products.length; i++) {
          // Skip unavailable products
          if (products[i].dataset.available == 'false') { continue; }

          let item = {
            "id": Number(products[i].dataset.id),
            "quantity" : 1,
            "properties": {}
          }

          // Add Mount Builder context properties
          for (const [key, value] of Object.entries(this.context.context)) {
            if(value){
              let skey = "_Mount_Builder_" + key
              item["properties"][skey] = value
            }
          }
          items.push(item);
        }

        // Only proceed if we have items to add
        if (items.length === 0) {
          console.log('No available products to bundle');
          return;
        }

        let data = { items };

        try {
          const cartState = await this.postCartAddRequest(data, { includeMiniCartSections: true });
          await this.refreshMiniCartOrSyncCount(cartState);
          console.log('Bundle added to cart:', items.length, 'items');
        } catch (error) {
          console.error('Error adding bundle to cart:', error);
        }
      }
  }

  generateBreadcrumb(data) {
    let stepsArray;

    // Check if data is a string and try to parse it as JSON
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        console.error('Data provided is not valid JSON:', data);
        return ''; // Exit the function if data is not valid JSON
      }
    }

    // Convert object values to an array if data is an object
    if (typeof data === 'object' && data !== null) {
      stepsArray = Object.values(data).filter(value => value); // Filter out any falsy values like empty strings
    } else {
      console.error('Data is not an object:', data);
      return ''; // Exit the function if data is not an object
    }

    // Begin constructing the breadcrumb HTML
    let breadcrumbHtml = '<nav class="flex" aria-label="Breadcrumb"><ol role="list" class="flex items-center space-x-4">';

    // Loop to add each breadcrumb item with / icon SVG
    if (stepsArray.length > 1) {
      let isFirstAfterHome = false;

      stepsArray.forEach((label_obj, index) => {
        let label = Object.keys(label_obj)[0]

        // Only add the arrow icon for items after the first
        if (label == '<Home>') {
          // Use initial context if it exists, otherwise use the provided context
          const homeContext = this.initialContext || label_obj[label];
          isFirstAfterHome = true; // Mark that the next item is first after home

          // Adding the 'Home' link
          breadcrumbHtml += `
            <li>
              <div>
                <a href="#" class="text-gray-400 hover:text-gray-500">
                  <svg class="h-6 w-6 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path class="home-breadcrumb-step" data-new-context='${JSON.stringify(homeContext)}' fill-rule="evenodd" d="M9.293 2.293a1 1 0 011.414 0l7 7A1 1 0 0117 11h-1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-6H3a1 1 0 01-.707-1.707l7-7z" clip-rule="evenodd" />
                  </svg>
                  <span class="sr-only">Home</span>
                </a>
              </div>
            </li>`;
        } else {
          // Check if this is the first breadcrumb after home and we have an initial context
          const breadcrumbContext = (isFirstAfterHome && this.initialContext) ? this.initialContext : label_obj[label];
          isFirstAfterHome = false; // Reset the flag

          breadcrumbHtml += `
            <li>
              <div class="flex items-center">
                <svg class="h-6 w-6 flex-shrink-0 text-gray-300" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                  <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
                </svg>
                <a href="#" class="breadcrumb-step ml-4 text-lg font-medium text-gray-500 hover:text-gray-700" data-new-context='${JSON.stringify(breadcrumbContext)}'>${label}</a>
              </div>
            </li>`;
        }
      });
    }
    breadcrumbHtml += '</ol></nav>';

    return breadcrumbHtml;
  }

  async addToCartSingle(event) {
      const eventEl = this.getEventElement(event);
      if (!eventEl) return;

      // Check if it's a modern product card or legacy product tile
      const tile = eventEl.closest("[data-tile]");
      if (!tile) return;

      let product = tile.querySelector("product-tile");

      // If no product-tile element, it's a modern card - get data from the card itself
      if (!product) {
        product = tile; // The modern card has all the data attributes we need
      }

      let items =  [];
      let item = {
        "id": Number(product.dataset.id),
        "quantity" : 1,
        "properties": {

        }
      }
      for (const [key, value] of Object.entries(this.context.context)) {
        if(value){
          let skey = "_Mount_Builder_" + key
          item["properties"][skey] = value
        }
      }
      items.push(item);
      let data = { items };
      try {
        const cartState = await this.postCartAddRequest(data, { includeMiniCartSections: true });
        await this.refreshMiniCartOrSyncCount(cartState);
      } catch (error) {
        console.error('Error:', error);
      }
  }

  async handleDropdownChange(selectedDropdown, options, dropdowns, index) {
    const nextDropdownIndex = index + 1;

    // Reset and disable all subsequent dropdowns
    for (let i = nextDropdownIndex + 1; i < dropdowns.length; i++) {
      const dropdownKey = Object.keys(dropdowns[i])[0];
      const dropdown = this.container.querySelector(`[data-type='${dropdownKey}']`);

      // Disable corresponding dd-selectors
      const ddSelector = this.container.querySelector(`dd-selector[data-selector='${dropdownKey}']`);
      if (ddSelector) {
        ddSelector.dataset.disabled = "true";
        ddSelector.setAttribute('data-disabled', 'true');
        const valueDiv = ddSelector.querySelector('[data-value]');
        if (valueDiv) {
          valueDiv.textContent = dropdowns[i][dropdownKey];
        }
      }
    }

    if (nextDropdownIndex < dropdowns.length) {
      const nextDropdownKey = Object.keys(dropdowns[nextDropdownIndex])[0];
      const nextDropdown = this.container.querySelector(`[data-type='${nextDropdownKey}']`);
      //nextDropdown.disabled = false;

      const selectedValue = selectedDropdown.value;
      let nextOptions = [];

      if (index === 0) {
        nextOptions = options[selectedValue] ? options[selectedValue] : [];
      } else {
        const firstDropdownValue = this.container.querySelector(`[data-type='${Object.keys(dropdowns[0])[0]}']`).value;
        nextOptions = options[firstDropdownValue] ? options[firstDropdownValue][selectedValue] : [];
      }

      if (nextOptions) {
        this.populateDropdown(nextDropdown, nextOptions)
      }

      // Enable the corresponding dd-selector for next dropdown
      const ddSelector = this.container.querySelector(`dd-selector[data-selector='${nextDropdownKey}']`);
      if (ddSelector) {
        ddSelector.dataset.disabled = "false";
        ddSelector.removeAttribute('data-disabled');
        const valueDiv = ddSelector.querySelector('[data-value]');
        if (valueDiv) {
          valueDiv.textContent = dropdowns[nextDropdownIndex][nextDropdownKey];
        }
      }
    } else {
      // we just filled in the last dropdown, fill in all the dropdown answers into the context.context
      this.container.querySelectorAll('select').forEach(el => {
        this.context.context[el.getAttribute('data-type')] = el.value
      })

      await this.navigateToContext(this.context.context)
    }
  }

  populateDropdown(dropdownElement, options) {
    ///Add Remove Options first
    let i, L = dropdownElement.options.length - 1;
    for(i = L; i > 0; i--) {
       dropdownElement.remove(i);
    }

    if (Array.isArray(options)) {
    } else {
      options = Object.keys(options)
    }

    if (typeof dropdownElement.dataset.type === 'string' && dropdownElement.dataset.type.includes('year')){
      // options
      options = options.sort((a, b) => Number(b) - Number(a));
    } else {
      options = options.sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
    }

    options.forEach(option => {
      const optionElement = document.createElement("option");
      optionElement.text = option;
      optionElement.value = option;
      dropdownElement.add(optionElement);
    });
  }

  buildDropDown(data) {
    fetch(`${window.routes.root_url}?section_id=api-mb-dd`)
      .then((response) => response.text())
      .then((text) => {
        const listHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-api-content]').innerHTML;

        this.container.innerHTML = listHTML;

        // Center the heading
        const heading = this.container.querySelector('[data-heading]');
        heading.innerText = data.header_question;
        heading.parentElement.classList.add('text-center');

        const listContainer = this.container.querySelector('#dd-list');
        const ddContainer = this.container.querySelector('#dd-selectors');

        const dropDownTemplate = this.container.querySelector('[data-type]');
        const multiDownTemplate = this.container.querySelector('[data-selector]');

        ddContainer.innerHTML = "";
        listContainer.innerHTML = "";

        // Update container classes to use flexbox for centering
        ddContainer.className = 'flex flex-wrap gap-4 justify-center px-4 md:px-0';
        listContainer.className = 'flex flex-wrap gap-4 justify-center hidden px-4 md:px-0';

        // Create and append dropdowns
        data.dropdowns.forEach((dropdownObject, index) => {
          const dropdownKey = Object.keys(dropdownObject)[0];
          const itemLabel = dropdownObject[dropdownKey];
          const itemNode = dropDownTemplate.cloneNode(true);
          const multiNode = multiDownTemplate.cloneNode(true);

          // Set consistent width - dropdowns will size to content with centered text
          itemNode.className = 'input select min-w-[200px] max-w-xs text-center';
          multiNode.className = 'relative min-w-[200px] max-w-xs';

          // Set the data-type and data-selector attributes
          itemNode.dataset.type = dropdownKey;
          multiNode.dataset.selector = dropdownKey;
          itemNode.dataset.index = index;

          // Fix the dropdown list to ensure last item is visible
          const searchContainer = multiNode.querySelector('[data-search]');
          const dropdownList = multiNode.querySelector('[data-list]');

          if (searchContainer && dropdownList) {
            // Ensure the search container can expand as needed
            searchContainer.style.minHeight = 'auto';
            searchContainer.style.maxHeight = '400px';

            // Ensure list has proper scrolling
            dropdownList.style.maxHeight = '350px';
            dropdownList.style.overflowY = 'auto';
            dropdownList.style.paddingBottom = '8px';
          }

          // Placeholder option - disabled and selected by default
          const placeholder = document.createElement("option");
          placeholder.text = itemLabel;
          placeholder.value = "";
          placeholder.disabled = true;
          placeholder.selected = true;
          itemNode.add(placeholder);

          // Populate the first dropdown
          if (index === 0) {
            this.populateDropdown(itemNode, data.options);

            // After populating, ensure the custom dropdown list is also populated if you're using it
            // You may need to call your custom dropdown population method here
          } else {
            multiNode.setAttribute("data-disabled", true);
          }

          // Add event listener for changes
          itemNode.addEventListener('change', (e) => {
            this.handleDropdownChange(e.currentTarget, data.options, data.dropdowns, index);
          });

          // Append directly to containers (flex will handle the layout)
          listContainer.appendChild(itemNode);
          ddContainer.appendChild(multiNode);

          let customClass = 'select-' + Math.floor(Math.random() * 10000);
          itemNode.classList.add(customClass);
        });
      })
      .catch((e) => {
        console.error(e);
      });
  }

  buildImageList(data){
    fetch(`${window.routes.root_url}?section_id=api-mb-image-list`)
      .then((response) => response.text())
      .then((text) => {
        const listHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-api-content]').innerHTML;
        this.container.innerHTML = "";
        this.container.innerHTML = listHTML;

        // Get typography settings from data attributes
        const headingTag = this.getAttribute('data-heading-tag') || 'h2';
        const headingSize = this.getAttribute('data-heading-size') || 'text-lg md:text-xl';
        const titleSize = this.getAttribute('data-title-size') || 'text-lg md:text-xl';
        const headingAlignment = this.getAttribute('data-heading-alignment') || 'text-center';

        // Get the new image cards setting
        const enableImageCards = this.getAttribute('data-enable-image-cards') === 'true';

        // Update heading element and styling
        const headingElement = this.container.querySelector('[data-heading]');
        if (headingElement) {
          // Change the tag name
          const newHeading = document.createElement(headingTag);
          newHeading.setAttribute('data-heading', '');
          newHeading.innerText = data.header_question;

          // Apply typography classes
          const headingContainer = headingElement.parentElement;
          headingContainer.className = `font-heading font-medium ${headingSize} mb-10 pt-4 md:pt-0 ${headingAlignment}`;

          // Replace the old heading with the new one
          headingElement.parentNode.replaceChild(newHeading, headingElement);
        }

        let listContainer = this.container.querySelector('#image-list');
        let imageNode = this.container.querySelector('[data-type]').cloneNode(true);
        listContainer.innerHTML = "";

        // Count the number of images
        const imageCount = Object.keys(data.image_list).length;

        if (enableImageCards) {
          // Modern card layout
          this.buildModernImageCards(data, listContainer, imageCount, titleSize);
        } else {
          // Original layout
          this.buildOriginalImageList(data, listContainer, imageNode, imageCount, titleSize);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  buildModernImageCards(data, listContainer, imageCount, titleSize) {
    // Count total items
    const totalItems = Object.keys(data.image_list).length;

    // Calculate starting column for centering on desktop (lg breakpoint)
    const getStartColumn = (totalItems) => {
      // For lg:grid-cols-6 layout - all items stay on one row
      switch(totalItems) {
        case 1: return 'lg:col-start-3'; // Centers 1 item (starts at column 3)
        case 2: return 'lg:col-start-3'; // Centers 2 items (starts at column 3)
        case 3: return 'lg:col-start-2'; // Centers 3 items (starts at column 2)
        case 4: return 'lg:col-start-2'; // Centers 4 items (starts at column 2, spans 4 columns total)
        case 5: return 'lg:col-start-1'; // 5 items start at column 1 (with one gap)
        default: return ''; // 6 or more items don't need offset
      }
    };

    // Set up responsive grid
    const startColumn = getStartColumn(totalItems);
    listContainer.className = 'grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6 max-w-7xl mx-auto place-content-center px-4 md:px-0';

    let itemIndex = 0;
    for (const key in data.image_list) {
      let item = data.image_list[key];

      // Create card element using DOM methods
      const cardElement = document.createElement('div');

      // Apply start column class only to the first item on desktop
      let cardClasses = 'modern-image-card';
      if (itemIndex === 0 && startColumn) {
        cardClasses += ` ${startColumn}`;
      }

      cardElement.className = cardClasses;
      cardElement.dataset.type = key;

      // Create image container
      const imageContainer = document.createElement('div');
      imageContainer.className = 'card-image-container';

      // Create image
      const img = document.createElement('img');
      img.src = item.url;
      img.alt = item.text;
      img.className = 'card-image';
      img.loading = 'lazy';

      // Create title container
      const titleContainer = document.createElement('div');
      titleContainer.className = 'card-title';

      // Create title
      const title = document.createElement('h3');
      title.className = `font-medium text-gray-900 ${titleSize}`;
      title.innerHTML = item.text.replace(/(\u2122|\u00AE)/g, '<sup>$1</sup>');

      // Assemble the card
      imageContainer.appendChild(img);
      titleContainer.appendChild(title);
      cardElement.appendChild(imageContainer);
      cardElement.appendChild(titleContainer);

      // Check if this is the IntelliSkin option
      if ((key === 'IntelliSkin®' || key.toLowerCase().includes('intelliskin')) && this.context.context.data_set !== 'Component') {
        cardElement.addEventListener('click', (e) => {
          e.preventDefault();

          // Extract device info from current context
          const deviceMake = this.context.context.device_make;
          const deviceModel = this.context.context.device_model;

          // Format for GDS builder
          const gdsContext = {
            "Device Make": deviceMake,
            "Device Model": deviceModel
          };

          // Redirect to GDS builder with context
          const queryParams = new URLSearchParams({
            context: JSON.stringify(gdsContext)
          });

          window.location.href = `/pages/gds-builder?${queryParams.toString()}`;
        });
      } else {
        // Normal mount builder flow
        cardElement.addEventListener('click', (e) => {
          // Remove selected class from all cards
          listContainer.querySelectorAll('.modern-image-card').forEach(card => {
            card.classList.remove('selected');
          });

          // Add selected class to clicked card
          cardElement.classList.add('selected');

          let field = e.currentTarget.dataset.type;
          this.context.context[this.context.field] = field;
          this.navigateToContext(this.context.context);
        });
      }

      listContainer.appendChild(cardElement);
      itemIndex++;
    }
  }

  buildOriginalImageList(data, listContainer, imageNode, imageCount, titleSize) {
    // Define width classes based on image count (original logic)
    let widthClasses = '';
    if (imageCount === 1) {
      // Single image - keep it reasonably sized and centered
      widthClasses = 'w-full max-w-xs md:max-w-sm lg:max-w-md mx-auto';
    } else if (imageCount === 2) {
      // Two images - make them nicely sized and well-spaced
      widthClasses = 'w-full sm:w-1/2 md:w-2/5 lg:w-1/3 px-4 md:px-6';
    } else if (imageCount === 3) {
      // Three images - slightly larger than 4
      widthClasses = 'w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 px-2 md:px-3';
    } else if (imageCount === 4) {
      // Four images - good balanced size
      widthClasses = 'w-1/2 md:w-1/4 lg:w-1/5 xl:w-1/6 px-2 md:px-2';
    } else if (imageCount === 5) {
      // Five images
      widthClasses = 'w-1/2 md:w-1/3 lg:w-1/5 px-2 md:px-2';
    } else {
      // Six or more images - use original sizing
      widthClasses = 'w-1/2 md:w-1/3 lg:w-1/6 px-2 md:px-0';
    }

    // Adjust container for better spacing (original logic)
    if (imageCount === 2) {
      listContainer.className = 'flex justify-center flex-wrap gap-4 md:gap-8 max-w-5xl mx-auto';
    } else if (imageCount === 1) {
      listContainer.className = 'flex justify-center flex-wrap';
    } else if (imageCount === 3) {
      listContainer.className = 'flex justify-center flex-wrap max-w-8xl mx-auto';
    } else if (imageCount === 4) {
      listContainer.className = 'flex justify-center flex-wrap max-w-8xl mx-auto';
    } else {
      listContainer.className = 'flex justify-center flex-wrap';
    }

    for (const key in data.image_list) {
      let item = data.image_list[key];
      let itemNode = imageNode.cloneNode(true);

      // Update the width classes for this item
      itemNode.className = `group cursor-pointer ${widthClasses} mb-4`;

      // Enhanced to detect and superscript trademarks
      const textWithTrademarkSuperscripted = item.text.replace(/(\u2122|\u00AE)/g, '<sup>$1</sup>');
      const titleElement = itemNode.querySelector('[data-title]');
      titleElement.innerHTML = textWithTrademarkSuperscripted;

      // Apply custom title size from settings
      titleElement.className = `min-w-[70%] inline-block pb-2 transition-all border-b-2 border-transparent group-hover:border-storm border-transparent ${titleSize}`;

      itemNode.querySelector('[data-img]').src = item.url;
      itemNode.dataset.type = key;

      // Check if this is the IntelliSkin option
      if ((key === 'IntelliSkin®' || key.toLowerCase().includes('intelliskin')) && this.context.context.data_set !== 'Component') {
        itemNode.addEventListener('click', (e) => {
          e.preventDefault();

          // Extract device info from current context
          const deviceMake = this.context.context.device_make;
          const deviceModel = this.context.context.device_model;

          // Format for GDS builder
          const gdsContext = {
            "Device Make": deviceMake,
            "Device Model": deviceModel
          };

          // Redirect to GDS builder with context
          const queryParams = new URLSearchParams({
            context: JSON.stringify(gdsContext)
          });

          window.location.href = `/pages/gds-builder?${queryParams.toString()}`;
        });
      } else {
        // Normal mount builder flow
        itemNode.addEventListener('click', (e) => {
          let field = e.currentTarget.dataset.type;
          this.context.context[this.context.field] = field;
          this.navigateToContext(this.context.context);
        });
      }

      listContainer.append(itemNode);
    }
  }

  close() {
  }

  handleBodyClick(e) {
  }

  // For Objects With condition: If an object has a condition property, it must be a function that returns a boolean. The class manipulation will only occur if this function returns true
  // condition: () => !this.allResults.classList.contains('hidden')
  manageClasses(classChanges) {
    classChanges.forEach(change => {
      // Skip button visibility changes - those are handled by toggleButtonVisibility
      if (change.selector === '#back-btn' ||
          change.selector === '[data-all-results]' ||
          change.selector === '[data-show-end-result-collection]' ||
          change.selector === '[data-start-over]') {
        return;
      }

      if (!change.condition || change.condition()) {
        const element = this.querySelector(change.selector);
        if (element) {
          const classes = change.class.split(' ');

          if (change.action === 'add') {
            classes.forEach(cls => element.classList.add(cls));
          } else if (change.action === 'remove') {
            classes.forEach(cls => element.classList.remove(cls));
          } else if (change.action === 'replace') {
            element.classList.replace(change.class, change.newClass);
          }
        }
      }
    });
  }
}

customElements.define('mount-builder', MountBuilder);

class DDSelector extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('[data-input]');
    this.value = this.querySelector('[data-value]');
    this.list = this.querySelector('[data-list]');
    this.search = this.querySelector('[data-search]');
    this.isOpen = false;
    this.highlightedIndex = -1;
  }

  connectedCallback() {
    // Add relative positioning to the parent container
    this.classList.add('relative');

    // Setup search input listener
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 500).bind(this));

    // Add keyboard navigation for input
    this.input.addEventListener('keydown', (e) => {
      this.handleKeyNavigation(e);
    });

    // Toggle dropdown on value click
    this.value.addEventListener('click', (e) => {
      e.stopPropagation();
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target) && this.isOpen) {
        this.close();
      }
    });

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });

    // Initialize the dropdown as closed with proper classes
    this.initializeDropdown();

    // Set initial value
    const listOptions = document.querySelector(`[data-type='${this.dataset.selector}']`);
    if (listOptions && listOptions.options.length > 0) {
      this.value.innerHTML = listOptions.options[0].text;
    }
  }

  initializeDropdown() {
    // Set initial styles using Tailwind classes
    this.search.classList.add(
      'absolute',
      'top-full',
      'left-0',
      'right-0',
      'z-50',
      'mt-1',
      'bg-white',
      'border',
      'border-gray-300',
      'rounded-md',
      'shadow-lg',
      'invisible',
      'opacity-0',
      'transform',
      'scale-95',
      'transition-all',
      'duration-200',
      'ease-out',
      'max-h-64',
      'overflow-auto'
    );

    // Ensure the value element is styled as clickable
    this.value.classList.add('cursor-pointer', 'select-none');

    // Add styles to the list container for better UX
    this.list.classList.add('py-1');
  }

  close() {
    this.clear();
    this.isOpen = false;
    this.highlightedIndex = -1;

    // Use Tailwind classes for smooth closing animation
    this.search.classList.remove('visible', 'opacity-100', 'scale-100');
    this.search.classList.add('invisible', 'opacity-0', 'scale-95');

    // Clear search input
    if (this.input) {
      this.input.value = '';
    }
  }

  open() {
    if (this.dataset.disabled === 'true') return;

    // Close all other dropdowns
    document.querySelectorAll('dd-selector').forEach((selector) => {
      if (selector !== this && selector.close) {
        selector.close();
      }
    });

    this.createList();
    this.isOpen = true;
    this.highlightedIndex = -1;

    // Use Tailwind classes for smooth opening animation
    this.search.classList.remove('invisible', 'opacity-0', 'scale-95');
    this.search.classList.add('visible', 'opacity-100', 'scale-100');

    // Only focus on desktop - check for touch capability
    if (this.input && !this.isMobileDevice()) {
      setTimeout(() => this.input.focus(), 100);
    }
  }

  isMobileDevice() {
    // Check multiple indicators for mobile/touch devices
    return (
      ('ontouchstart' in window) ||
      (navigator.maxTouchPoints > 0) ||
      (navigator.msMaxTouchPoints > 0) ||
      (window.matchMedia("(max-width: 768px)").matches)
    );
  }

  createList() {
    this.list.innerHTML = "";
    const listOptions = document.querySelector(`[data-type='${this.dataset.selector}']`);

    if (!listOptions || !listOptions.options) return;

    let listItems = "";
    listOptions.options.forEach((el, index) => {
      if (index === 0) {
        this.value.innerHTML = el.text;
      } else {
        listItems += `<li
          data-index="${index - 1}"
          class="dd-option px-4 py-2 cursor-pointer select-none transition-colors duration-150"
          >${el.text}</li>`;
      }
    });

    this.list.innerHTML = listItems;

    // Add hover and click handlers to list items
    this.list.querySelectorAll('li').forEach((el, index) => {
      // Mouse enter - highlight on hover
      el.addEventListener('mouseenter', () => {
        this.highlightedIndex = index;
        this.updateHighlight();
      });

      // Mouse leave - remove highlight
      el.addEventListener('mouseleave', () => {
        if (this.highlightedIndex === index) {
          this.highlightedIndex = -1;
          this.updateHighlight();
        }
      });

      // Click handler
      el.addEventListener('click', (e) => {
        e.stopPropagation();
        this.selectOption(el.textContent);
      });
    });
  }

  updateHighlight() {
    const items = this.list.querySelectorAll('li:not(.no-results)');
    items.forEach((el, index) => {
      // Remove all highlight classes first
      el.classList.remove('bg-gray-100', 'bg-blue-50', 'text-blue-600');

      // Add highlight to the current index
      if (index === this.highlightedIndex) {
        el.classList.add('bg-blue-50', 'text-blue-600');
      }
    });
  }

  handleKeyNavigation(e) {
    if (!this.isOpen) return;

    const visibleItems = Array.from(this.list.querySelectorAll('li:not(.hidden):not(.no-results)'));

    switch(e.key) {
      case 'ArrowDown':
        e.preventDefault();
        this.highlightedIndex = Math.min(this.highlightedIndex + 1, visibleItems.length - 1);
        this.updateHighlight();
        this.scrollToHighlighted();
        break;

      case 'ArrowUp':
        e.preventDefault();
        this.highlightedIndex = Math.max(this.highlightedIndex - 1, -1);
        this.updateHighlight();
        this.scrollToHighlighted();
        break;

      case 'Enter':
        e.preventDefault();
        if (this.highlightedIndex >= 0 && visibleItems[this.highlightedIndex]) {
          this.selectOption(visibleItems[this.highlightedIndex].textContent);
        }
        break;
    }
  }

  scrollToHighlighted() {
    const visibleItems = Array.from(this.list.querySelectorAll('li:not(.hidden):not(.no-results)'));
    if (this.highlightedIndex >= 0 && visibleItems[this.highlightedIndex]) {
      const highlightedEl = visibleItems[this.highlightedIndex];
      highlightedEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  selectOption(text) {
    this.value.innerHTML = text;
    const selectElement = document.querySelector(`[data-type='${this.dataset.selector}']`);

    if (selectElement) {
      selectElement.value = text;

      // Dispatch change event
      if ("createEvent" in document) {
        const evt = document.createEvent("HTMLEvents");
        evt.initEvent("change", false, true);
        selectElement.dispatchEvent(evt);
      } else {
        selectElement.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    this.close();
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    this.highlightedIndex = -1;

    if (!searchTerm.length) {
      this.clear();
    } else {
      this.getSearchResults(searchTerm);
    }

    this.updateHighlight();
  }

  clear() {
    const listItems = this.list.querySelectorAll('li');
    listItems.forEach(el => {
      el.classList.remove('hidden');
    });

    // Remove any "no results" message
    const noResults = this.list.querySelector('.no-results');
    if (noResults) noResults.remove();
  }

  getSearchResults(searchTerm) {
    const listItems = this.list.querySelectorAll('li:not(.no-results)');
    let hasVisibleItems = false;

    listItems.forEach(el => {
      if (el.textContent.toLowerCase().includes(searchTerm.toLowerCase())) {
        el.classList.remove('hidden');
        hasVisibleItems = true;
      } else {
        el.classList.add('hidden');
      }
    });

    // Handle "No results" message
    const existingNoResults = this.list.querySelector('.no-results');

    if (!hasVisibleItems) {
      if (!existingNoResults) {
        const noResults = document.createElement('li');
        noResults.className = 'no-results px-4 py-2 text-gray-500 italic select-none';
        noResults.textContent = 'No results found';
        this.list.appendChild(noResults);
      }
    } else if (existingNoResults) {
      existingNoResults.remove();
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  // Clean up event listeners when element is removed
  disconnectedCallback() {
    document.removeEventListener('click', this.closeOnClickOutside);
    document.removeEventListener('keydown', this.closeOnEscape);
  }
}

customElements.define('dd-selector', DDSelector);
